import React, { useState, useRef, useEffect, useCallback } from 'react';
import {
    Youtube, Instagram, Twitter, Globe, ChevronLeft, ChevronRight,
    ExternalLink, X, Play, ShoppingBag, Tv, Video, Trees, Facebook,
    createLucideIcon,
    Film,
    Heart,
    Eye,
    EyeOff,
    Bookmark,
    BookmarkCheck,
    Star,
    StickyNote,
    Check,
    Sparkles,
    Gift,
} from 'lucide-react';

/* ═══════════════════════════════════════════════════════════════
   RECORDED CALLS - add YouTube embed URLs here in code
═══════════════════════════════════════════════════════════════ */
const RECORDED_CALLS = {
    seller: [
        { url: 'https://www.youtube.com/embed/G_SrrU-5cJ4', title: 'Sourcing will never be the same again' },
        { url: 'https://www.youtube.com/embed/oGJ3gGbBSe8', title: 'The NEW Way to Find Profitable Leads for Amazon & Walmart' },
        { url: 'https://www.youtube.com/embed/x81df9k-M7E', title: 'MSP Alerts & More: Updates Overview | Seller Pro Webinar' },
        { url: 'https://www.youtube.com/embed/33LfN3AZel8', title: 'Lets Talk Whatnot, Then MSP Questions! | Seller Pro Webinar' },
        { url: 'https://www.youtube.com/embed/V_s37zBd6O8', title: 'Seller Pro Webinar - Lets Answer Your Questions!' },
        { url: 'https://www.youtube.com/embed/fr23MF6WjhM', title: 'Your Daily Sourcing Routine, Step by Step | Seller Pro Webinar' },
        { url: 'https://www.youtube.com/embed/a3mOndUr9EA', title: 'Walmart Shipments on MSP with 7figuregrammy' },
        { url: 'https://www.youtube.com/embed/9ZCq9-eIBj8', title: 'Auto Run Is INSANELY Powerful - Watch This!' },
        { url: 'https://www.youtube.com/embed/y-ECVfLKKHE', title: 'Live From the Conference: Seller Pro Webinar at Our Booth!' },
        { url: 'https://www.youtube.com/embed/rxyAvRKb7oM', title: 'We Spent 2 Hours on MSP and Barely Scratched the Surface' },
        { url: 'https://www.youtube.com/embed/hQxqqTkQPJY', title: 'Seller Pro Webinar - Storefront Stalking & Sourcing and more!' },
        { url: 'https://www.youtube.com/embed/naK-yJUov8A', title: 'Aug 5 | Full MSP Inventory Walkthrough - $1,000s Reimbursed!' },
        { url: 'https://www.youtube.com/embed/vgQbJIcOE8s', title: 'This MSP Inventory Launch Left 150 Sellers Speechless' },
        { url: 'https://www.youtube.com/embed/aBNqUV09LJU', title: 'NEW Sourcing Method! Seller Pro Webinar July 22' },
        { url: 'https://www.youtube.com/embed/KwH71wEYTHo', title: 'Must Watch: Seller Pro Webinar (July 15)' },
        { url: 'https://www.youtube.com/embed/hwxUTSNDhQ4', title: 'July 8 Seller Pro Webinar: Live Sourcing!!' },
        { url: 'https://www.youtube.com/embed/pXFVWWi8vxU', title: 'Seller Pro Webinar: Oh no! 20 Days Left! 40 New Features!  (July 1)' },
        { url: 'https://www.youtube.com/embed/-riBIxzPSHw', title: 'Seller Pro Webinar June 24 - The Future of MSP' },
        { url: 'https://www.youtube.com/embed/4Jl4COvPbG4', title: 'Seller Pro Webinar June 17 | Tips & Hidden Gems' },
        { url: 'https://www.youtube.com/embed/OQr3ckZG-1k', title: 'Secret Sourcing Method | Seller Pro Webinar' },
        { url: 'https://www.youtube.com/embed/wwA616tKK6I', title: 'Live Sourcing for Amazon and Walmart Using The Universal Scans' },
        { url: 'https://www.youtube.com/embed/fdXcNFsGs_0', title: 'Our First Seller Pro Webinar - Live Sourcing Amazon and Walmart' },
    ],
    influencer: [
        { url: 'https://www.youtube.com/embed/z5jPa1kPBK8', title: 'Product research for investment in the new AI era' },
        { url: 'https://www.youtube.com/embed/j7zEHIa1Mok', title: 'The New Way to Do AIP Product Research for Investment' },
        { url: 'https://www.youtube.com/embed/6le9eF_Nyx4', title: 'How to Get More Clicks on Your Videos | Influencer Pro Webinar' },
        { url: 'https://www.youtube.com/embed/llVSMtqcqHI', title: 'So Many Updates, It Feels Like 3.0! | MIP 2.0 Webinar' },
        { url: 'https://www.youtube.com/embed/jgxwCmv4Pbk', title: 'Lets Fix Your AIP Storefront | MIP 2.0 Webinar' },
        { url: 'https://www.youtube.com/embed/1Q8NxHYUKug', title: 'Influencer Pro Webinar: Big Updates & Winning Strategies for 2026' },
        { url: 'https://www.youtube.com/embed/ooDNb8upe1I', title: 'The Best AIP Toolset! MIP 2.0 Webinar and Updates' },
        { url: 'https://www.youtube.com/embed/clfd-kCmYw0', title: 'Airbnb + AIP = $1,000s? MIP Webinar + Trip Recap' },
        { url: 'https://www.youtube.com/embed/-fwoNlZzcYc', title: 'Live MIP Webinar: Ideas From the ASD Market Floor!' },
        { url: 'https://www.youtube.com/embed/2qRwR-SlltI', title: 'MIP 2.0 Webinar: Lets Build MIP 2.0 Together! (Aug 18)' },
        { url: 'https://www.youtube.com/embed/ho3i0pql6V0', title: 'MIP 2.0 | Influecer Pro Weekly Webinar' },
        { url: 'https://www.youtube.com/embed/4rd0JDa8mtc', title: 'Aug 4 | What Is MIP? Let\'s Do a Walkthrough!' },
        { url: 'https://www.youtube.com/embed/jlxTDkGKecI', title: 'The FASTEST Way to Film Product Reviews (Influencer Pro Webinar)' },
        { url: 'https://www.youtube.com/embed/F8feacubQE4', title: 'Influencer Pro Webinar July 21 | Guides & How-Tos' },
        { url: 'https://www.youtube.com/embed/9fM1X3E5G4I', title: 'Must Watch: Influencer Pro Webinar (July 14)' },
        { url: 'https://www.youtube.com/embed/du8n4KVvvBo', title: 'July 7 Influencer Pro Webinar: Best Tips and Q&A for AIP' },
        { url: 'https://www.youtube.com/embed/1jaG343iMhk', title: 'Influencer Pro Webinar - 40 New Features!! (June 30)' },
        { url: 'https://www.youtube.com/embed/lDMG9hTcB9k', title: 'Influencer Pro Webinar June 23 - Lets Talk AIP' },
        { url: 'https://www.youtube.com/embed/CBhpRZrsJfI', title: 'Influencer Pro Webinar June 16 | New Updates' },
        { url: 'https://www.youtube.com/embed/wlmKNqxZbKM', title: 'How to Scale Your AIP Business | Influencer Pro Webinar' },
        { url: 'https://www.youtube.com/embed/LEmQUe3Zfs8', title: 'The COMPLETE Amazon Influencer Program Guide - Step by Step from A to Z' },
        { url: 'https://www.youtube.com/embed/7CDUJhSb96U', title: 'Our First Influencer Pro Webinar - Getting Started with AIP' },
    ],
    general: [
        { url: 'https://www.youtube.com/embed/zQPu6fdicG4', title: 'We Hit 150 Live Attendees - Our Biggest Webinar Yet' },
        { url: 'https://www.youtube.com/embed/X3oWz0-k_Fg', title: 'Above the BB + Reverse Scan | Training Webinar' },
        { url: 'https://www.youtube.com/embed/bf1gWubVLoA', title: 'Amazing Spoilers and Funny Moments | Live Webinar' },
        { url: 'https://www.youtube.com/embed/5DR81BVwymU', title: '200 Ungated Brands In 15 Minutes + ULS Variation Leads | Apr 29 Webinar' },
        { url: 'https://www.youtube.com/embed/E6Lk701vvnw', title: 'April 22 Webinar: We Really Tried NOT to Call It MSP 2.0!' },
        { url: 'https://www.youtube.com/embed/W0eyKuffUN4', title: 'April 8 Amazing Webinar | Seller Pro and Influencer Pro' },
        { url: 'https://www.youtube.com/embed/zpzfkvNut8w', title: 'Live Webinar! Tutorial & New Features Walkthrough!' },
        { url: 'https://www.youtube.com/embed/DveHQVNFAKA', title: 'Live Webinar - Showing some tools' },
        { url: 'https://www.youtube.com/embed/rL9ms-XDoG0', title: 'Huge MSP Live Webinar Recording March 25th' },
        { url: 'https://www.youtube.com/embed/1xpm8sUrac4', title: 'First Webinar Had No Audio So We Talked About It Instead (LOL)' },
    ],
};

/* ═══════════════════════════════════════════════════════════════
   SPANISH VIDEOS - add YouTube embed URLs here in code
═══════════════════════════════════════════════════════════════ */
const SPANISH_CREATOR = {
    name: 'Carlos Fazzini',
    photo: 'hium/carlos.png',           // e.g. '/hium/creator.jpeg'
    description: `The founder of Academia de Amazon, a Spanish-speaking education platform dedicated to helping sellers build a more professional Amazon arbitrage business in the U.S. marketplace.

With more than five years of experience in Amazon arbitrage, coaching, and account management, Carlos specializes in teaching sellers how to analyze products, understand market data, protect their capital, and make better sourcing decisions.

His approach is based on a simple principle: tools are not shortcuts. A tool should help the seller think better, filter faster, reduce noise, and make more professional decisions.

Through Academia de Amazon, Carlos provides practical training for Spanish-speaking sellers across the United States and Latin America, combining weekly live sessions, real product analysis, sourcing frameworks, Keepa interpretation, and step-by-step education for beginners and intermediate sellers.

Carlos’ MultiSeller Pro trainings in Spanish are designed to help users understand the tool clearly, configure it correctly, and use it with criteria, context, and professional judgment.

The goal is not only to show how to use MultiSeller Pro, but how to use it as part of a complete decision-making process for Online Arbitrage, Retail Arbitrage, ungating, product validation, and capital protection.`,
    links: [
        { label: 'YouTube', icon: 'youtube', url: 'https://youtube.com/@AcademiadeAmazon' },
        { label: 'Instagram', icon: 'instagram', url: 'https://www.instagram.com/carlos.fazzini/' },
        { label: 'Linkedin', icon: 'linkedin', url: 'https://www.linkedin.com/in/carlosfazziniamazon/' },
        { label: 'Free Skool', icon: 'skool', url: 'https://www.skool.com/academia-de-amazon' },
        { label: 'Private Community', icon: 'community', url: 'https://www.academiadeamazon.com/membresia' },
    ],
    accentColor: '#dc2626',
};

const SPANISH_VIDEOS = [
    { url: 'https://www.youtube.com/embed/wvXGq3qOB14', title: 'MultiSellerPro en Español: cómo encontrar oportunidades durante Prime Day' },
    { url: 'https://www.youtube.com/embed/8sLh0C_OmTo', title: 'Prime Day EN VIVO con MultiSellerPro: buscamos oportunidades reales' },
    { url: 'https://www.youtube.com/embed/GLvd8dm8tHY', title: 'MultiSellerPro en Español: un ASIN, múltiples rutas de investigación' },
    { url: 'https://www.youtube.com/embed/A0hb0UlEEbQ', title: 'MultiSellerPro en Español: cómo conectar búsquedas entre Amazon, Walmart y retailers' },
    { url: 'https://www.youtube.com/embed/4zd9NGyE-nM', title: 'MultiSellerPro en Español: preparando Back to School con búsquedas inteligentes' },
    { url: 'https://www.youtube.com/embed/zp_5C7JWhuE', title: 'MultiSellerPro en Español: búsquedas en vivo desde marcas, tiendas y productos' },
    { url: 'https://www.youtube.com/embed/4Ynq6MNKiKo', title: 'MultiSellerPro en Español: nuevas funciones y una rutina de búsqueda en vivo' },
    { url: 'https://www.youtube.com/embed/-81tARoMwVo', title: 'MultiSellerPro en Español: de marcas desbloqueadas a productos para analizar' },
    { url: 'https://www.youtube.com/embed/iODFihPibWk', title: 'MultiSeller Pro en Español: ungating, marcas desbloqueadas y oportunidades reales' },
    { url: 'https://www.youtube.com/embed/0LpNMNn_dz4', title: 'MultiSeller Pro en Español: nuevas actualizaciones, demo y preguntas en vivo' },
    { url: 'https://www.youtube.com/embed/WE7WxaHbcYg', title: 'Cómo usar Ungating Crawler en MultiSeller Pro | Desbloquea marcas en segundo plano' },
    { url: 'https://www.youtube.com/embed/6d-9d99nHQQ', title: 'Cómo usar Ungating Machine en MultiSeller Pro | Desbloquea marcas con ASINs' },
    { url: 'https://www.youtube.com/embed/I9uWnxqF-eE', title: 'MultiSeller Pro en Español: configuración inicial, extensión y dashboard' },
    { url: 'https://www.youtube.com/embed/iSDMyMZXytg', title: 'MultiSeller Pro en Español: rutina práctica para encontrar candidatos sin perder tiempo' },
    { url: 'https://www.youtube.com/embed/SpuD7Zju3T8', title: 'Cómo encontrar productos más rápido en Amazon (Demo en vivo con su creador)' },
    { url: 'https://www.youtube.com/embed/Ed7udu8G5sQ', title: 'MultiSellerPro en Español: Cómo tomar mejores decisiones para encontrar productos rentables' },
    { url: 'https://www.youtube.com/embed/NHOujSJqRbc', title: 'No todo producto rentable es una buena oportunidad | Análisis de producto en Amazon Parte 2' },
    { url: 'https://www.youtube.com/embed/JThPiKvMemQ', title: 'MultiSeller Pro en Español: cómo encontrar productos sin depender de la herramienta' },
];

/* ═══════════════════════════════════════════════════════════════
   SELLERS
═══════════════════════════════════════════════════════════════ */
const INTRO_VIDEOS = {
    seller: {
        title: 'Seller Pro Intro Video',
        subtitle: 'New to Seller Pro? Start here.',
        url: 'https://www.youtube.com/embed/YgLvigaFy9M',
        color: '#0d9488',
        icon: ShoppingBag,
    },
    influencer: {
        title: 'Influencer Pro Intro Video (Full Walkthrough)',
        subtitle: 'Full MIP 2.0 walkthrough',
        url: 'https://www.youtube.com/embed/aalZVCg91Kw',
        color: '#2563eb',
        icon: Tv,
    },
};

const SELLERS = [
    {
        id: 'tracey',
        name: 'Tracey Shelley',
        marketplaces: ['amazon', 'walmart', 'ebay'],
        photo: '/hium/tracey.jpeg',
        description: 'Dr. Tracey Shelley has been selling online for the past 30 years on eBay, Amazon, and Walmart.  She has worked with numerous sellers to help them build their businesses.  She has developed the WOW: Winning on Walmart brand to specifically help sellers succeed on Walmart.',
        services: 'Information on courses and paid services can be found at Linktree.',
        links: [
            { label: 'Linktree', icon: 'linktree', url: 'https://linktr.ee/7figuregrammy' },
            { label: 'Instagram', icon: 'instagram', url: 'https://www.instagram.com/7figuregrammy/' },
            { label: 'YouTube', icon: 'youtube', url: 'https://www.youtube.com/@7figuregrammy77' },
            { label: 'TikTok', icon: 'tiktok', url: 'https://www.tiktok.com/@wowwinningonwm' },
            { label: 'X.com', icon: 'x', url: 'https://x.com/7figuregrammy' },
        ],
        accentColor: '#2563eb',
        shorts: [
            { url: 'https://www.youtube.com/embed/9pL3tbuCV8k', type: 'yt', title: 'Tip #1' },
        ],
        videos: [
            { url: 'https://www.youtube.com/embed/RrYng-agCbM', title: 'MultiSellerPro: How to Retire Items Quickly' },
            { url: 'https://www.youtube.com/embed/XBwIUg8zGqs', title: 'MSP Inventory Deep Dive: Catalog - Managing your WM Inventory Easily' },
            { url: 'https://www.youtube.com/embed/Pz3uMeLPT64', title: 'HUGE ANNOUNCEMENT: MultiSellerPro Inventory for Walmart is HERE!' },
            { url: 'https://www.youtube.com/embed/NnTWvidPgUI', title: 'The Easiest Way to Print Walmart GTIN Labels (And MORE)' },
            { url: 'https://www.youtube.com/embed/wj4glo-t0TU', title: 'Unlocking Amazon Ungating - How to Find Brands YOU Can Sell!' },
            { url: 'https://www.youtube.com/embed/RtPl45xpA3A', title: 'Scan ANY website to find profitable products in ONE CLICK!' },
            { url: 'https://www.youtube.com/embed/Ge_wAQSjeKo', title: 'Game Changer for OA Sourcing! MultiSellerPros new LIVE Search' },
            { url: 'https://www.youtube.com/embed/_q1eSNq48cs', title: 'Print GTIN Labels for Walmart FROM YOUR BROWSER using MultiSellerPro' },
            { url: 'https://www.youtube.com/embed/QcZcq1yx8gI', title: 'Ungating on Amazon for New Sellers - How to Ungate Brands Quickly using MultiSellerPro' },
            { url: 'https://www.youtube.com/embed/3Maet1GEbrQ', title: 'Walmart Shipments - ITS vs Distributed and how MultiSellerPro can help!' },
            { url: 'https://www.youtube.com/embed/O-Sot4HSvRM', title: 'LIVE Sourcing with MultiSellerPro' },
            { url: 'https://www.youtube.com/embed/aMu2ZOQdJz8', title: 'WOW presents MultiSellerPro for RA Sellers' },
            { url: 'https://www.youtube.com/embed/lnS2pumlwpE', title: 'WOW presents MultiSellerPro - Tools for OA Sellers' },
        ],
    },
    {
        id: 'bryan',
        name: 'Bryan Limitless',
        marketplaces: ['amazon', 'walmart', 'ebay'],
        photo: '/hium/bryan.jpeg',
        description: 'I went from installing kitchen cabinets to ecom. Selling on Walmart, eBay and scaling the Amazon influencer program. I teach others to diversify income across all platforms.',
        links: [
            { label: 'Linktree', icon: 'linktree', url: 'https://linktr.ee/Bryan_limitless' },
            { label: 'Instagram', icon: 'instagram', url: 'https://www.instagram.com/bryan_limitless/' },
            { label: 'YouTube', icon: 'youtube', url: 'https://www.youtube.com/@SourceFlipRepeatOfficial' },
            { label: 'TikTok', icon: 'tiktok', url: 'https://www.tiktok.com/@bryan_limitless' },
        ],
        services: 'Amazon and Walmart Premium Lead Service, Walmart Prep Center, AIP done for you Approval, 1 on 1 coaching (Amazon, Walmart, eBay, AIP, Virtual Assistants).',
        accentColor: '#7c3aed',
        shorts: [
            { url: 'https://www.instagram.com/p/Dc-E1RvuiP5/', type: 'ig', title: 'We have the best sourcing tools and the universal scan is by far my favorite for oa sourcing' },
            { url: 'https://www.instagram.com/p/Dc-UbHTOQjw/', type: 'ig', title: 'Getting Started' },
            { url: 'https://www.instagram.com/p/Dc-U05-OgTd/', type: 'ig', title: 'Adding your buy list to  @multisellerpro inventory' },
            { url: 'https://www.instagram.com/p/Dc-WRE6uccR/', type: 'ig', title: '@multisellerpro dashboard tutorial' },
            { url: 'https://www.instagram.com/p/DavP01bOGE2/', type: 'ig', title: 'W2W Sourcing Tips' },
            { url: 'https://www.instagram.com/p/Dawhb65OFyx/', type: 'ig', title: 'The Universal Live Scan' },
            { url: 'https://www.instagram.com/p/DawmJ7AuVCY/', type: 'ig', title: 'The Dashboard' },
            { url: 'https://www.instagram.com/p/Dawnq6tumHN/', type: 'ig', title: 'The Ungate Crawler' },
            { url: 'https://www.instagram.com/p/DawpDqeuwMs/', type: 'ig', title: 'The Chrome Extension' },
            { url: 'https://www.instagram.com/p/Da4TzkBuXdx/', type: 'ig', title: 'The Mobile App' },
            { url: 'https://www.instagram.com/p/DZN40pqxNIP/', type: 'ig', title: 'This is how @multisellerpro can speed up shipments when doing Walmart' },
            { url: 'https://www.instagram.com/p/DZQ6fsaROwh/', type: 'ig', title: 'Keepa Gated Status with Ido' },
            { url: 'https://www.youtube.com/embed/16DLzxYLC8g', type: 'yt', title: 'Tip #1' },
            { url: 'https://www.instagram.com/p/DWXYZCQDvSH/', type: 'ig', title: 'What is @multisellerpro and how it can speed up productivity all in 1 app', thumbUrl: 'https://scontent.cdninstagram.com/v/t51.71878-15/658332958_2334503643705959_1885721443386023982_n.jpg?stp=dst-jpg_e35_tt6&_nc_cat=110&ccb=7-5&_nc_sid=18de74&efg=eyJlZmciOiJDTElQUy5pZ19zaGltX3JlYWQuNjQweDExMzYuQzMifQ%3D%3D&_nc_ohc=MYjEC_whvPsQ7kNvwHvtYFL&_nc_oc=Adrw4EV865ikTiCW_IkcG9e38iyjEaihTHPQkD6Vh-qAL7cai0pFWnCJsvkrex6Df6ldxH3bUH7XoE06mi0k5vdi&_nc_zt=23&_nc_ht=scontent.cdninstagram.com&_nc_gid=xAEe4R1VlZsHc6ydNAq95w&_nc_ss=7b6a8&oh=00_Af7o4lenkYkBE70KtXZOnYmArv2X4cv7SADjiWC9zpmBPw&oe=6A1A2DEA&ig_cache_key=Mzg2MTY2MjQ3OTAxMzU3Mzc2Nw%3D%3D.2-ccb7-5' },
            { url: 'https://www.instagram.com/p/DWW0GM8DgGs/', type: 'ig', title: 'Sourcing Walmart 2 Walmart', thumbUrl: 'https://scontent.cdninstagram.com/v/t51.71878-15/657912912_924136273918664_6238864706942389669_n.jpg?stp=dst-jpg_e35_tt6&_nc_cat=106&ccb=7-5&_nc_sid=18de74&efg=eyJlZmciOiJDTElQUy5pZ19zaGltX3JlYWQuNjQweDExMzYuQzMifQ%3D%3D&_nc_ohc=5B0xq-iDALAQ7kNvwH3x5s-&_nc_oc=AdrbJcqjv6PxLt5xmJPUiDzDTJ_98T2UZE40ZPDbu-Og_Za6vR4LdM9JCrrcoVyupkvJXAo3qiEj6HycVVbUX_m9&_nc_zt=23&_nc_ht=scontent.cdninstagram.com&_nc_gid=xAEe4R1VlZsHc6ydNAq95w&_nc_ss=7b6a8&oh=00_Af59ICGsSs3dnSZRtv4d5sCU9JybcJ0eRWUlfEkM30NH0w&oe=6A1A50A8&ig_cache_key=Mzg2MTUwMjg1NTE0NDY2OTYxMg%3D%3D.2-ccb7-5' },
            { url: 'https://www.instagram.com/p/DWR-aKRkQEF/', type: 'ig', title: 'Showing off my new favorite sourcing tool', thumbUrl: 'https://scontent.cdninstagram.com/v/t51.71878-15/656292331_818903543915477_6168701761676422220_n.jpg?stp=dst-jpg_e35_tt6&_nc_cat=102&ccb=7-5&_nc_sid=18de74&efg=eyJlZmciOiJDTElQUy5pZ19zaGltX3JlYWQuNjQweDExMzYuQzMifQ%3D%3D&_nc_ohc=mgGA-wSTj7sQ7kNvwHAsfLH&_nc_oc=Adq42auaWiFFZMtzWX91LYZ9D0EBcH4R9XRcKveqN62SI0Ylczqqmaxu2ZAZ2lS4Welvk7TF2_tEWf6fStx1RZba&_nc_zt=23&_nc_ht=scontent.cdninstagram.com&_nc_gid=xAEe4R1VlZsHc6ydNAq95w&_nc_ss=7b6a8&oh=00_Af78WfLeUOAuXT-a5jHDdMXpOPRGTr7W5z2ysdcJo3pb9w&oe=6A1A2A5C&ig_cache_key=Mzg2MDE0MDgzMjI1NTQ0MzIwNQ%3D%3D.2-ccb7-5' },
        ],
        videos: [],
    },
    {
        id: 'ido',
        name: 'Ido Friedman',
        marketplaces: ['amazon', 'walmart'],
        photo: '/hium/ido.jpeg',
        description: 'Passionate programmer since age 10. Now building MultiSellerPro. Always pushing the boundaries of technology to solve real-world problems and create impactful solutions that deliver FAST results that online sellers can benefit from IMMEDIATELY.',
        links: [
            { label: 'YouTube', icon: 'youtube', url: 'https://www.youtube.com/@MultiSellerPro' },
            { label: 'Instagram', icon: 'instagram', url: 'https://www.instagram.com/idofriedman9/' },
            { label: 'Facebook', icon: 'facebook', url: 'https://www.facebook.com/groups/multisellerpro/' },
        ],
        accentColor: '#0d9488',
        shorts: [
            { url: 'https://www.youtube.com/embed/T2RfSQdg7Dk', type: 'yt', title: 'Another Amazing Feature You Requested Is LIVE! (Seller Pro)' },
            { url: 'https://www.youtube.com/embed/RowhYwW8VRE', type: 'yt', title: 'eBay Lister' },
            { url: 'https://www.youtube.com/embed/gNo196IYJFU', type: 'yt', title: 'Book Scanner' },
            { url: 'https://www.youtube.com/embed/LfxZTgi2_3I', type: 'yt', title: 'The BEST Wholesale Scan!' },
            { url: 'https://www.youtube.com/embed/HY_CMxoa3VU', type: 'yt', title: 'Tip #1' },
            { url: 'https://www.youtube.com/embed/sAJOctc7OQU', type: 'yt', title: 'Tip #1' },
            { url: 'https://www.youtube.com/embed/RwE7Kpis9pU', type: 'yt', title: 'Tip #1' },
            { url: 'https://www.youtube.com/embed/YEIBzdk-JKA', type: 'yt', title: 'Tip #1' },
            { url: 'https://www.instagram.com/p/DYfyU5bNv6L/', type: 'ig', title: 'The Universal Scan🚀', thumbUrl: 'https://scontent.cdninstagram.com/v/t51.71878-15/702811522_1699320471065991_8655331719771523324_n.jpg?stp=cmp1_dst-jpg_e35_s640x640_tt6&_nc_cat=105&ccb=7-5&_nc_sid=18de74&efg=eyJlZmdfdGFnIjoiQ0xJUFMuYmVzdF9pbWFnZV91cmxnZW4uQzMifQ%3D%3D&_nc_ohc=W54Glpg9beMQ7kNvwHjlOqJ&_nc_oc=AdrrA-SgbsarxQRbMWHO9gGk_0Z4E9Z_61N6X6N2LbIH7yqGyqo5YHwkzttIBSkWtRGayTl8KK-obzvO2V8WViFt&_nc_zt=23&_nc_ht=scontent.cdninstagram.com&_nc_gid=iGwyNCdZuESs3WaFeTFcdw&_nc_ss=7b6a8&oh=00_Af7vKYVNb8Z2CCyoOYDwfSeLpAyJ2VjWLdkkLqWG2p8YAQ&oe=6A1A2E52' },
            { url: 'https://www.instagram.com/p/DYDaRHioj3R/', type: 'ig', title: 'Another MSP gems kinda day!', thumbUrl: 'https://scontent.cdninstagram.com/v/t51.71878-15/688299154_948531374632324_7472899299114937033_n.jpg?stp=cmp1_dst-jpg_e35_s640x640_tt6&_nc_cat=102&ccb=7-5&_nc_sid=18de74&efg=eyJlZmdfdGFnIjoiQ0xJUFMuYmVzdF9pbWFnZV91cmxnZW4uQzMifQ%3D%3D&_nc_ohc=D7ynvg-9OR8Q7kNvwFxVX05&_nc_oc=Adr8iFU1OqzI48ZsATpSjRi0wUsKNNwAQe7qfAfMMvueWg4NklW-UC85nV7VmE89s71dyRU5W5CzjkGhfFYgpjH9&_nc_zt=23&_nc_ht=scontent.cdninstagram.com&_nc_gid=CFUvnksJyA1cLDbFRJfKxA&_nc_ss=7b6a8&oh=00_Af4I9KeNYNgk9aVAGNB5YevOboRATV_zQj4V4xh2BzIBlg&oe=6A1A42E3' },
            { url: 'https://www.instagram.com/p/DYAWvFuoS-_/', type: 'ig', title: 'Did you know it??', thumbUrl: 'https://scontent.cdninstagram.com/v/t51.71878-15/671757701_1288590219555342_5320997800231169439_n.jpg?stp=cmp1_dst-jpg_e35_s640x640_tt6&_nc_cat=100&ccb=7-5&_nc_sid=18de74&efg=eyJlZmdfdGFnIjoiQ0xJUFMuYmVzdF9pbWFnZV91cmxnZW4uQzMifQ%3D%3D&_nc_ohc=eQmSG_cDmBIQ7kNvwFVq70D&_nc_oc=AdpdRF53oQVIWyopvrXQ-Cuzklads8ub4TU44LBOgME2aOmAs6dLgAnQGvl501eWwritnacL6ADhZm22HrwcG-Uu&_nc_zt=23&_nc_ht=scontent.cdninstagram.com&_nc_gid=y7fu0D4HTHTcI4naHFm8BA&_nc_ss=7b6a8&oh=00_Af5RFmHIwVTFgKyMPe6TeK9RA3B_vuzp4ZxsjLQB-BPTqw&oe=6A1A4D2F' },
            { url: 'https://www.instagram.com/p/DX9e9KroqdJ/', type: 'ig', title: 'Storefront Scanner & Emails', thumbUrl: 'https://scontent.cdninstagram.com/v/t51.71878-15/671098055_1646191923888360_8746278261035647891_n.jpg?stp=cmp1_dst-jpg_e35_s640x640_tt6&_nc_cat=111&ccb=7-5&_nc_sid=18de74&efg=eyJlZmdfdGFnIjoiQ0xJUFMuYmVzdF9pbWFnZV91cmxnZW4uQzMifQ%3D%3D&_nc_ohc=-3gaFCgcOd0Q7kNvwEGhOJJ&_nc_oc=AdrOQx7fwNk6yxHXKLoU4YPYEW9Xjq5tLSaq6K6kuWTKXRAn2UYFqN09qtxXh4KA21lD5WCcWcp-N-CfQZZKy0zz&_nc_zt=23&_nc_ht=scontent.cdninstagram.com&_nc_gid=bViwpARgBEI_1_SMPwz8Tw&_nc_ss=7b6a8&oh=00_Af5SCQwHbwObw7kNCantDQpSlUE_XJGyK9M4pg-UE-uv6g&oe=6A1A4D73' },
            { url: 'https://www.instagram.com/p/DX7FRZ1s-qn/', type: 'ig', title: 'Ungated Brands', thumbUrl: 'https://scontent.cdninstagram.com/v/t51.71878-15/685832201_2424472407963066_1356880715540655860_n.jpg?stp=cmp1_dst-jpg_e35_s640x640_tt6&_nc_cat=111&ccb=7-5&_nc_sid=18de74&efg=eyJlZmdfdGFnIjoiQ0xJUFMuYmVzdF9pbWFnZV91cmxnZW4uQzMifQ%3D%3D&_nc_ohc=X9jo7TvY3EcQ7kNvwEHDrxT&_nc_oc=AdrZaiWXkKIe9f0ljwriTlHScWv9A56u426CyVQkm7DQcH6ILc7g7lBb3s4K57OE8fv2P31bdWS2T1MLvyUqHQG1&_nc_zt=23&_nc_ht=scontent.cdninstagram.com&_nc_gid=ZVOw395JRPKtZNEQG6Cbdw&_nc_ss=7b6a8&oh=00_Af7N5KR5gvBjvxSdBWMXrUCZ8GW-hJ5fwMh2zbCInCTstg&oe=6A1A27CE' },
        ],
        videos: [
            { url: 'https://www.youtube.com/embed/zSyMvyLhPSw', title: 'We Automated The Universal Live Scan!!!' },
            { url: 'https://www.youtube.com/embed/YNYZxWcNfSc', title: 'Storefront Sourcing Is HERE (New Way to Source)' },
            { url: 'https://www.youtube.com/embed/EpjARHY9nHk', title: 'This Universal Scan Changed Everything!' },
            { url: 'https://www.youtube.com/embed/5tZO4DlHmWk', title: 'The BEST Wholesale Scan!' },
            { url: 'https://www.youtube.com/embed/sFWdAhKzLuw', title: 'The Amazing Universal Reverse Scan' },
            { url: 'https://www.youtube.com/embed/rtlDOpvow3s', title: 'The Amazing Universal Live Scan' },
            { url: 'https://www.youtube.com/embed/0iD7kcHARyQ', title: 'Chrome Extension / Mobile App Custom Layout & Size' },
            { url: 'https://www.youtube.com/embed/OZnUgisQLvU', title: 'The Amazing Local Scan Feature (Step by Step Guide)' },
            { url: 'https://www.youtube.com/embed/6IAeczSBXyI', title: 'How to source for specific brands using MSP' },
            { url: 'https://www.youtube.com/embed/Ll5H_Jh1TFM', title: 'MultiSellerPro Filters - Full Overview' },
            { url: 'https://www.youtube.com/embed/Li7iGXo3Sfk', title: 'New Buy List System' },
            { url: 'https://www.youtube.com/embed/fZ3Gql0NqgI', title: 'Amazon to Walmart (A2W) using MSP' },
        ],
    },
    {
        id: 'jim',
        name: 'Jim Cockrum',
        marketplaces: ['amazon'],
        photo: '/hium/jim.jpg',
        description: 'Silent Sales Machine, Proven and MySilentTeam for Amazon FBA and Online Sellers.',
        links: [
            { label: 'YouTube', icon: 'youtube', url: 'https://www.youtube.com/@silentjimdotcom' },
            { label: 'Facebook', icon: 'facebook', url: 'https://www.facebook.com/groups/mysilentteam' },
        ],
        accentColor: '#0d1b94',
        shorts: [],
        videos: [
            { url: 'https://www.youtube.com/embed/-bwoZt8Pack', title: 'How even new resellers can quickly find 100s of ungated brands to sell on Amazon' },
        ],
    },
    {
        id: 'jimmy',
        name: 'Ask Jimmy Smith',
        marketplaces: ['amazon'],
        photo: '/hium/jimmy.jpg',
        description: 'Jimmy Smith has been selling on Amazon since 2015 and has trained thousands of sellers through his YouTube channel @AskJimmySmith and his private courses and communities. His Business Building Legends community brings together hundreds of members focused on growing and scaling their Amazon business, plus the Amazon Influencer program, Walmart, eBay, and other platforms. Check it out at https://www.askjimmysmith.com/legends.',
        links: [
            { label: 'YouTube', icon: 'youtube', url: 'https://www.youtube.com/@AskJimmySmith' },
            { label: 'Legends', icon: 'askjimmysmith', url: 'https://www.askjimmysmith.com/legends' },
            { label: 'Free Training', icon: 'askjimmysmith', url: 'https://www.askjimmysmith.com/freetraining' },
            { label: 'Instagram', icon: 'instagram', url: 'https://www.instagram.com/askjimmysmith' },
            { label: 'TikTok', icon: 'tiktok', url: 'https://www.tiktok.com/@askjimmysmith' },
            { label: 'X', icon: 'x', url: 'https://www.x.com/askjimmysmith' },
            { label: 'Facebook', icon: 'facebook', url: 'https://www.facebook.com/askjimmysmith' },
        ],
        accentColor: '#2c940d',
        shorts: [],
        videos: [
            { url: 'https://www.youtube.com/embed/Yn3V5tseDbc', title: 'This Amazon Influencer Tool Records, Edits & Posts For You | MultiSeller Pro' },
            { url: 'https://www.youtube.com/embed/kS7BuUaHiko', title: 'Find Unlimited Amazon FBA Leads with This Tool!' },
            { url: 'https://www.youtube.com/embed/ZPfgGTPjphw', title: 'Find Ungated Brands in SECONDS with This Tool!' },
        ],
    },
    {
        id: 'maddie',
        name: 'Coach Maddie',
        marketplaces: ['amazon', 'walmart'],
        photo: '/hium/maddie.png',
        description: 'Ecom seller for 3 years on Walmart and Amazon. EDU Coach for 2 years. Helping others get started and achieve the freedom I did. Check out YouTube for an intro video about me, full deep dives into software\'s & how to succeed. Check IG for Tips & Tricks.',
        links: [
            { label: 'Instagram', icon: 'instagram', url: 'https://www.instagram.com/amzjourney_coachmaddie/' },
            { label: 'YouTube', icon: 'youtube', url: 'https://www.youtube.com/@maddiee7453' },
            { label: 'Coaching', icon: 'coaching', url: 'https://calendly.com/maddie-ecomdegreeuniversity/edu-intro' },
            { label: 'Product Leads', icon: 'leads', url: 'https://whop.com/checkout/plan_M3HmfLB0fvRbK' },
        ],
        accentColor: '#c418b0',
        shorts: [
            { url: 'https://www.instagram.com/amzjourney_coachmaddie/reel/Dak7xXPxEAc/', type: 'ig', title: 'The biggest secret in e-commerce', thumbUrl: '' },
            { url: 'https://www.instagram.com/amzjourney_coachmaddie/reel/DXwtH1zoXDf/', type: 'ig', title: 'Day 10', thumbUrl: 'https://scontent.cdninstagram.com/v/t51.82787-15/684150245_18033453446798951_3365117410616375765_n.jpg?stp=cmp1_dst-jpg_e35_s640x640_tt6&_nc_cat=103&ccb=7-5&_nc_sid=18de74&efg=eyJlZmdfdGFnIjoiQ0xJUFMuYmVzdF9pbWFnZV91cmxnZW4uQzMifQ%3D%3D&_nc_ohc=CMg5OKK6g5IQ7kNvwEqhakC&_nc_oc=AdoshoDCrndguWNZ0LrkrqKNwZ2aTzUvDCtx_ZiG9Nyt69BNgMllwXReouRAXoPlXTTyzTy-nLmdUy5qlomtLNWV&_nc_zt=23&_nc_ht=scontent.cdninstagram.com&_nc_gid=iAuKeWOhkMk9PBJbnzl8Zg&_nc_ss=7b6a8&oh=00_Af4EzI4fj0kLWfbE15zG22eu0sZjnUfVDSrTj8-C9tO-pA&oe=6A1B7ABD' },
            { url: 'https://www.instagram.com/amzjourney_coachmaddie/reel/DXrkcxCCBeZ/', type: 'ig', title: 'Day 9', thumbUrl: 'https://scontent.cdninstagram.com/v/t51.82787-15/680797684_18033201644798951_4921519339214544974_n.jpg?stp=cmp1_dst-jpg_e35_s640x640_tt6&_nc_cat=106&ccb=7-5&_nc_sid=18de74&efg=eyJlZmdfdGFnIjoiQ0xJUFMuYmVzdF9pbWFnZV91cmxnZW4uQzMifQ%3D%3D&_nc_ohc=pMCdqmovDAkQ7kNvwHbI20O&_nc_oc=AdoMFSqMEEaQxoE3KXzTOsbSOJ3AcGfxWNWq1Qto6aIRhXM1HPvkrbC_dfNMx7mAXQOyH2uREM6OBez1wI1ZU811&_nc_zt=23&_nc_ht=scontent.cdninstagram.com&_nc_gid=qSyq-mrQMMEZ_xrDrQf33g&_nc_ss=7b6a8&oh=00_Af5Yfg776W7aiNzewqFDFSyzTBbzw-sM-6AG71BBFp8vFw&oe=6A1B767B' },
            { url: 'https://www.instagram.com/amzjourney_coachmaddie/reel/DXZg6sRxvDg/', type: 'ig', title: 'Day 8', thumbUrl: 'https://scontent.cdninstagram.com/v/t51.82787-15/671124460_18032216090798951_8063048263515377387_n.jpg?stp=cmp1_dst-jpg_e35_s640x640_tt6&_nc_cat=106&ccb=7-5&_nc_sid=18de74&efg=eyJlZmdfdGFnIjoiQ0xJUFMuYmVzdF9pbWFnZV91cmxnZW4uQzMifQ%3D%3D&_nc_ohc=2cq30LKqEasQ7kNvwH91Z3N&_nc_oc=AdobJnxNHOlxcZC8WGRH3eKcBgAQvgCS8mRaaTVDkgt1JKGLVNiuMrMNYkOp0N6ngVcoIs_j3PEEjBXDlZdRd8RY&_nc_zt=23&_nc_ht=scontent.cdninstagram.com&_nc_gid=8Z2chJeofFI-nDFmMwRXSQ&_nc_ss=7b6a8&oh=00_Af4a8vS4OpxxmTReLdtdjab80Hufq5bFJEl-tSSP77yxoQ&oe=6A1B85CC' },
            { url: 'https://www.instagram.com/amzjourney_coachmaddie/reel/DXPNyGuR0tZ/', type: 'ig', title: 'Day 7', thumbUrl: 'https://scontent.cdninstagram.com/v/t51.82787-15/671799083_18031689476798951_8676988326436597612_n.jpg?stp=cmp1_dst-jpg_e35_s640x640_tt6&_nc_cat=102&ccb=7-5&_nc_sid=18de74&efg=eyJlZmdfdGFnIjoiQ0xJUFMuYmVzdF9pbWFnZV91cmxnZW4uQzMifQ%3D%3D&_nc_ohc=-A7LO-CSej8Q7kNvwHSvR2Q&_nc_oc=Adr7-TnOUAj2S_sLq8LdIg6HvDBRiV5QiVL-YNrs4mgdAuriN66lsRvk__32GzZm2SRBMMY8KIrISj5tk1jdQnAn&_nc_zt=23&_nc_ht=scontent.cdninstagram.com&_nc_gid=stkYomcO8IjzQa8I0i4dlA&_nc_ss=7b6a8&oh=00_Af7eTsiYp2AXhpemSJjsbBPv_tnvqDB-chuVbUyH2rH6yw&oe=6A1B8C34' },
            { url: 'https://www.instagram.com/amzjourney_coachmaddie/reel/DXHfVBQptgD/', type: 'ig', title: 'Day 6', thumbUrl: 'https://scontent.cdninstagram.com/v/t51.82787-15/670635815_18031301717798951_3620281259535794091_n.jpg?stp=cmp1_dst-jpg_e35_s640x640_tt6&_nc_cat=110&ccb=7-5&_nc_sid=18de74&efg=eyJlZmdfdGFnIjoiQ0xJUFMuYmVzdF9pbWFnZV91cmxnZW4uQzMifQ%3D%3D&_nc_ohc=Nl1g4L6dAJYQ7kNvwEgz9Ci&_nc_oc=Adrf14_vyDM1Rg6DJSaX1-PCPnBw171pyVOctzzSMC5kclQRbuHSbsx0ZhAxMwiaeZ3Q3H4Pp77UUeqyvoC3cz8t&_nc_zt=23&_nc_ht=scontent.cdninstagram.com&_nc_gid=vZicDnpHtb013QJxW5OZtg&_nc_ss=7b6a8&oh=00_Af4zM9krp-1ha0Gp81nH6vH77D20zs-u3uturY6g7xLipQ&oe=6A1B8DF5' },
            { url: 'https://www.instagram.com/amzjourney_coachmaddie/reel/DW_1EbckbP5/', type: 'ig', title: 'Day 5', thumbUrl: 'https://scontent.cdninstagram.com/v/t51.82787-15/670409453_18030946211798951_9108679351170684713_n.jpg?stp=cmp1_dst-jpg_e35_s640x640_tt6&_nc_cat=105&ccb=7-5&_nc_sid=18de74&efg=eyJlZmdfdGFnIjoiQ0xJUFMuYmVzdF9pbWFnZV91cmxnZW4uQzMifQ%3D%3D&_nc_ohc=yyeRLTeKESUQ7kNvwEUbkRk&_nc_oc=AdqlUn9uuhmQ5hks9-a28grCh6Y5_d7d5dbqpxxaStTzGQ5uwYlh9-ewAgWnqbiAgFMy1-GenqJ7cPqDrJorfeHK&_nc_zt=23&_nc_ht=scontent.cdninstagram.com&_nc_gid=bSVdzTzX_ETsvGJ5daHhHw&_nc_ss=7b6a8&oh=00_Af5i9OF7ETkAtuFOrP--oYEPq6WlhCrtzdcZHo2omz0_hA&oe=6A1B89D3' },
            { url: 'https://www.instagram.com/amzjourney_coachmaddie/reel/DW6n6fexCjr/', type: 'ig', title: 'Day 4', thumbUrl: 'https://scontent.cdninstagram.com/v/t51.82787-15/659224377_18030679889798951_551981823139582238_n.jpg?stp=cmp1_dst-jpg_e35_s640x640_tt6&_nc_cat=109&ccb=7-5&_nc_sid=18de74&efg=eyJlZmdfdGFnIjoiQ0xJUFMuYmVzdF9pbWFnZV91cmxnZW4uQzMifQ%3D%3D&_nc_ohc=G_3jUD_vQRIQ7kNvwHWeO_g&_nc_oc=AdpslB1k96AiKaKCM89Nwa7LJN6h2bNhqiUSJbgmxeP9iFftjHGyV-3WUPIIIyFsdBQB2HRyd_8d4z0EahgJhfzX&_nc_zt=23&_nc_ht=scontent.cdninstagram.com&_nc_gid=v5Ja0DXb919hcuTnxDeUGw&_nc_ss=7b6a8&oh=00_Af6_62ooTU4tIMmorknKe7D8H9gf807qw-Ev3Q4y2QY1qA&oe=6A1B6E66' },
            { url: 'https://www.instagram.com/amzjourney_coachmaddie/reel/DW4Cmj1RbB1/', type: 'ig', title: 'Day 3', thumbUrl: 'https://scontent.cdninstagram.com/v/t51.82787-15/669933057_18030538901798951_7215243420765684342_n.jpg?stp=cmp1_dst-jpg_e35_s640x640_tt6&_nc_cat=106&ccb=7-5&_nc_sid=18de74&efg=eyJlZmdfdGFnIjoiQ0xJUFMuYmVzdF9pbWFnZV91cmxnZW4uQzMifQ%3D%3D&_nc_ohc=yAMrVXWt1iAQ7kNvwF7inrD&_nc_oc=AdorTLM0L9K1IeAsVocOJ2dAmqEKqfnUelRfcR-kVn_71ME1S4kpHqii78o7imkv53sGfAGOiEwyXl28DmQ5o9Vl&_nc_zt=23&_nc_ht=scontent.cdninstagram.com&_nc_gid=qvr7CfN-LXimlgwLKULy2A&_nc_ss=7b6a8&oh=00_Af6bJmiEz0Tf8C_y6F82wnYKv6ehXLm-edu-SzkxNuTEzA&oe=6A1B7286' },
            { url: 'https://www.instagram.com/amzjourney_coachmaddie/reel/DW1pTCIiCVw/', type: 'ig', title: 'Day 2', thumbUrl: 'https://scontent.cdninstagram.com/v/t51.82787-15/660741798_18030425456798951_5775265496796964544_n.jpg?stp=cmp1_dst-jpg_e35_s640x640_tt6&_nc_cat=105&ccb=7-5&_nc_sid=18de74&efg=eyJlZmdfdGFnIjoiQ0xJUFMuYmVzdF9pbWFnZV91cmxnZW4uQzMifQ%3D%3D&_nc_ohc=1aPaIE_709AQ7kNvwHPlFF_&_nc_oc=AdoKsU0sDkA2R1TM4QY2U7287-hBahHX2yDKr5cBmtbvXrRd_Ir5HfGDEz9adz6HSH4cwFbrn_bGQZmEzKKFvprV&_nc_zt=23&_nc_ht=scontent.cdninstagram.com&_nc_gid=SPAZm1Qapb871ITBfzjjGg&_nc_ss=7b6a8&oh=00_Af405DfISH1VhyFmNUXtqaphWH8Gc3idohEHMKK8Qxg_Iw&oe=6A1B5D47' },
            { url: 'https://www.instagram.com/amzjourney_coachmaddie/reel/DWy49hpxVzP/', type: 'ig', title: 'Day 1', thumbUrl: 'https://scontent.cdninstagram.com/v/t51.82787-15/660105708_18030286790798951_1022523867221672743_n.jpg?stp=cmp1_dst-jpg_e35_s640x640_tt6&_nc_cat=103&ccb=7-5&_nc_sid=18de74&efg=eyJlZmdfdGFnIjoiQ0xJUFMuYmVzdF9pbWFnZV91cmxnZW4uQzMifQ%3D%3D&_nc_ohc=2jhAlYwx5vQQ7kNvwEssWLo&_nc_oc=AdqhcPoNQqZdFIUJIz_DQh_muON5W2ue9mRMgsTN3qARSMh6d7TIBkvqinbNbo7cXLdYJMTGOTPoc12SoKl9Luwz&_nc_zt=23&_nc_ht=scontent.cdninstagram.com&_nc_gid=iouGwiCWgnv-xvy1-ExkUw&_nc_ss=7b6a8&oh=00_Af7gdNDvs56t0cBFYgpgVky_pHypL9bycxstOS7uduA9Mw&oe=6A1B7869' },
        ],
        videos: [
            { url: 'https://www.youtube.com/embed/mOwbDgmfxh8', title: 'Storefront Stalking Made Easy | Amazon & Walmart Seller Hack' },
            { url: 'https://www.youtube.com/embed/0UEGU2Hz2UY', title: 'Find Local Suppliers Fast with MSP Local Scan' },
            { url: 'https://www.youtube.com/embed/Z_eJ0xHshGw', title: 'How to find profitable deals in seconds' },
            { url: 'https://www.youtube.com/embed/K7QRFzhh4Uo', title: 'Stop Wasting Time Sourcing Products Manually!' },
        ],
    },
    {
        id: 'brandon',
        name: 'Sell With Brandon',
        marketplaces: ['amazon', 'walmart'],
        photo: '/hium/brandon.jpg',
        description: 'At 24 years old, I was able to quit my full time job and buy a house by reselling thousands of items out of my basement. Now, Im trying to teach others how to do the same.',
        services: 'Please see LinkTree Above',
        links: [
            { label: 'Instagram', icon: 'instagram', url: 'https://www.instagram.com/sellwithbrandon' },
            { label: 'Linktree', icon: 'linktree', url: 'https://linktr.ee/sellwithbrandon1' },
        ],
        accentColor: '#3b52d3',
        shorts: [
            { url: 'https://www.youtube.com/embed/5hCuk__GAAY', type: 'yt', title: 'Would you buy these to flip for 100% ROI?' },
            { url: 'https://www.youtube.com/embed/ybKc6ZxTDKA', type: 'yt', title: 'Selling on Walmart has never been easier than with MultiSellerPro 🚀' },
            { url: 'https://www.instagram.com/p/DZVXr-NxBk8/', type: 'ig', title: 'This new software is seriously a game changer', thumbUrl: '' },
        ],
        videos: [
            { url: 'https://www.youtube.com/embed/AgFkG3n1hww', title: 'A HUGE New Update Just Came Out For MultiSellerPro... If You Sell On Walmart, This Video Is For You' },
        ],
    },
    {
        id: 'bemo',
        name: 'Marvelin Umeh',
        marketplaces: ['amazon', 'walmart'],
        photo: '/hium/bemo.png',
        description: 'Amazon FBA and Walmart Marketplace seller with hands-on experience in product sourcing, inventory management, and marketplace growth. I help aspiring sellers launch and scale successful eCommerce businesses.',
        links: [
            { label: 'Instagram', icon: 'instagram', url: 'https://www.instagram.com/flipprx' },
            { label: 'Facebook', icon: 'facebook', url: 'https://www.facebook.com/share/18cy7BY2yk/?mibextid=wwXIfr' },
            { label: 'YouTube', icon: 'youtube', url: 'https://www.youtube.com/@marvelinumeh' },
        ],
        accentColor: '#d3c93b',
        shorts: [],
        videos: [
            { url: 'https://www.youtube.com/embed/Li2-J0nECDY', title: 'Amazon to Walmart!' },
            { url: 'https://www.youtube.com/embed/hOPHzv6OfRo', title: 'Storefront stalking using MultisellerPro Reverse Scan' },
        ],
    },
    {
        id: 'cody',
        name: 'Cody McCarson',
        marketplaces: ['amazon', 'walmart', 'ebay'],
        photo: '/hium/cody.png',
        description: 'Hi! My name is Cody and we resell items on Amazon, Walmart, eBay and others. DM anytime if we can help!',
        links: [
            { label: 'Instagram', icon: 'instagram', url: 'https://www.instagram.com/cody_does_reselling/' },
            { label: 'X', icon: 'x', url: 'https://x.com/codydoesamazon' },
            { label: 'TikTok', icon: 'tiktok', url: 'https://www.tiktok.com/@cody_does_reselling' },
        ],
        accentColor: '#940d0d',
        shorts: [
            { url: 'https://www.instagram.com/p/DZHic3zBjWZ/', type: 'ig', title: 'Image Search!', thumbUrl: '' },
            { url: 'https://www.instagram.com/p/DYAuoneBCjg/', type: 'ig', title: 'Scanner/calculator but you also get every other tool they offer!', thumbUrl: '' },
            { url: 'https://www.instagram.com/p/DY4OBECCK9U/', type: 'ig', title: '5700+ Ungated Brands', thumbUrl: 'https://scontent.cdninstagram.com/v/t51.71878-15/710431971_27191264207160181_5373377449915206427_n.jpg?stp=cmp1_dst-jpg_e35_s640x640_tt6&_nc_cat=111&ccb=7-5&_nc_sid=18de74&efg=eyJlZmdfdGFnIjoiQ0xJUFMuYmVzdF9pbWFnZV91cmxnZW4uQzMifQ%3D%3D&_nc_ohc=rGOBNxmgw7cQ7kNvwFAoVgl&_nc_oc=Ado12tjO3Vuj7IWCIFa9W3LzqFZIif8BvIjfjNaH9P7DeweTxlB7kXJllTsK-3CCoYF58IjRhv7OTeOmzHx-6sIY&_nc_zt=23&_nc_ht=scontent.cdninstagram.com&_nc_gid=_u5Df2IIvfGAEVtDuLK4Ng&_nc_ss=7b6a8&oh=00_Af55DyzfDRF4M1pam-bHexSOwZJ9JSeG9Z1uy3ukNJto5w&oe=6A1E8A44' },
            { url: 'https://www.instagram.com/p/DYrXiiRCY1d/', type: 'ig', title: 'Ungate Crawler', thumbUrl: 'https://scontent.cdninstagram.com/v/t51.71878-15/703988406_1527889742212516_1984766285520443281_n.jpg?stp=cmp1_dst-jpg_e35_s640x640_tt6&_nc_cat=110&ccb=7-5&_nc_sid=18de74&efg=eyJlZmdfdGFnIjoiQ0xJUFMuYmVzdF9pbWFnZV91cmxnZW4uQzMifQ%3D%3D&_nc_ohc=IVXsjSvcH2sQ7kNvwG6tA0s&_nc_oc=Adq627pKHkd6ZlDRpl3XYQKmxCu2Dg90B4bWq1KOMGHUxz0Bq44WnXnYKDyK5NhkiIuATI6ysamKvYLaie93G-Lq&_nc_zt=23&_nc_ht=scontent.cdninstagram.com&_nc_gid=V1myzrIIGxnDC9ZN1QERBg&_nc_ss=7b6a8&oh=00_Af5rkVvXAMbBmMwobEBMpYWEO94bgfFjZoH3TNzc3anIAg&oe=6A1B6CC6' },
            { url: 'https://www.instagram.com/p/DYdDUU2Bwc9/', type: 'ig', title: 'Stock Checker', thumbUrl: 'https://scontent.cdninstagram.com/v/t51.71878-15/696066898_1494171948753339_3400117866440624419_n.jpg?stp=cmp1_dst-jpg_e35_s640x640_tt6&_nc_cat=108&ccb=7-5&_nc_sid=18de74&efg=eyJlZmdfdGFnIjoiQ0xJUFMuYmVzdF9pbWFnZV91cmxnZW4uQzMifQ%3D%3D&_nc_ohc=4J-fGfXby2kQ7kNvwFKm8eq&_nc_oc=AdrEXFYRUHYQiRg4ptWOlQKnlUwPdl8tH7_soqHvV3vUddizIS5s393hfdCdCYr-MYltDORLukQIuD0hjP-4rXC5&_nc_zt=23&_nc_ht=scontent.cdninstagram.com&_nc_gid=R_W2gypo6ZqjFzSArWD8Eg&_nc_ss=7b6a8&oh=00_Af4mMxtG5TRAlj6d3454XCSRsYauRSNu8OpCcYOckZCfww&oe=6A1B6C1B' },
            { url: 'https://www.instagram.com/p/DX0I15Wim5L/', type: 'ig', title: 'Doing RA', thumbUrl: 'https://scontent.cdninstagram.com/v/t51.71878-15/683795944_797024739928143_306114552409679389_n.jpg?stp=cmp1_dst-jpg_e35_s640x640_tt6&_nc_cat=111&ccb=7-5&_nc_sid=18de74&efg=eyJlZmdfdGFnIjoiQ0xJUFMuYmVzdF9pbWFnZV91cmxnZW4uQzMifQ%3D%3D&_nc_ohc=KwlKIeWq8U4Q7kNvwHjr6HE&_nc_oc=Adqa23DmZWebDH55YoGlbRGsuQ5IzY3fXzVXWOflRbuJxgfBOKBrxlIDKVHUDbt1jLQleKPownvDApYllDkefw81&_nc_zt=23&_nc_ht=scontent.cdninstagram.com&_nc_gid=_vGghkD4OUYpbM2KNxvLLg&_nc_ss=7b6a8&oh=00_Af7fOMVjZ-QZCfo5TiTUPnfa7CI1oBAVTowSazzjHYwVdQ&oe=6A1B6FD3' },
            { url: 'https://www.instagram.com/p/DXU7861B6Uf/', type: 'ig', title: 'A2A Lead', thumbUrl: 'https://scontent.cdninstagram.com/v/t51.71878-15/673945603_1663007274632248_8333922396815668711_n.jpg?stp=cmp1_dst-jpg_e35_s640x640_tt6&_nc_cat=108&ccb=7-5&_nc_sid=18de74&efg=eyJlZmdfdGFnIjoiQ0xJUFMuYmVzdF9pbWFnZV91cmxnZW4uQzMifQ%3D%3D&_nc_ohc=FKq2mN37nhQQ7kNvwHZQD7v&_nc_oc=AdoMcxNiM3R00imIL_PjXIcBZa0woUo_Rf62gvCNvUd2P76LGQBo58_JWg5SgOyER6vnrq3RGOepV6HwOjddWk0J&_nc_zt=23&_nc_ht=scontent.cdninstagram.com&_nc_gid=_r36KHT92dhD_97mm6E54Q&_nc_ss=7b6a8&oh=00_Af538h8-OYb21TgMQs79yPqGTdtK0obO5oZCtbISy4qjLg&oe=6A1B489E' },
            { url: 'https://www.instagram.com/p/DXKvmPlBsIC/', type: 'ig', title: 'A2A Lead', thumbUrl: 'https://scontent.cdninstagram.com/v/t51.71878-15/670298687_1506755684381623_7242056011544183540_n.jpg?stp=cmp1_dst-jpg_e35_s640x640_tt6&_nc_cat=106&ccb=7-5&_nc_sid=18de74&efg=eyJlZmdfdGFnIjoiQ0xJUFMuYmVzdF9pbWFnZV91cmxnZW4uQzMifQ%3D%3D&_nc_ohc=8JDelAaKOyoQ7kNvwGg6ocO&_nc_oc=AdoiD4fHQ5Iz1k249u8ak2FubrPflbMoT0jKSEOOzM568ilfEjLCSDA_QkeuhQwL4IyLrAoIVx0BoOrxRp_rIFz4&_nc_zt=23&_nc_ht=scontent.cdninstagram.com&_nc_gid=whAU_4-MQqXPXKHblX8iyA&_nc_ss=7b6a8&oh=00_Af5y-O6SqrzuIFG2hrJyAyoscl5BT9NZzwqslHUUvXMmfg&oe=6A1B6E6B' },
        ],
        videos: [],
    },
];

/* ═══════════════════════════════════════════════════════════════
   INFLUENCERS
═══════════════════════════════════════════════════════════════ */
const INFLUENCERS = [
    {
        id: 'bryan',
        name: 'Bryan Limitless',
        photo: '/hium/bryan.jpeg',
        description: 'Teaching others to sell on all platforms and scale the Amazon influencer program. Rooting for everyone to leave their 9-5.',
        links: [
            { label: 'Linktree', icon: 'linktree', url: 'https://linktr.ee/Bryan_limitless' },
            { label: 'Instagram', icon: 'instagram', url: 'https://www.instagram.com/bryan_limitless/' },
            { label: 'YouTube', icon: 'youtube', url: 'https://www.youtube.com/@SourceFlipRepeatOfficial' },
            { label: 'TikTok', icon: 'tiktok', url: 'https://www.tiktok.com/@bryan_limitless' },
        ],
        services: 'AIP done for you Approval, 1 on 1 coaching, Virtual Assistants.',
        accentColor: '#7c3aed',
        shorts: [
            { url: 'https://www.instagram.com/p/DZKwxeguJ5l/', type: 'ig', title: 'The messaging system In multi influencer pro is how am able to send out 1000 messages a week in record time.' },
            { url: 'https://www.instagram.com/p/DZMCZ8xOJC4/', type: 'ig', title: 'List AIP products on eBay with just a few clicks' },
            { url: 'https://www.instagram.com/p/DZBDJLzR-0_/', type: 'ig', title: 'Here\'s one way you\'re able to increase your video count for AIP ( amazon influencer program)' },
            { url: 'https://www.instagram.com/p/DX1hvVXhTh5/', type: 'ig', title: 'our goal is to provide a software with so much value you dont need all the other expensive subscriptions', thumbUrl: 'https://scontent.cdninstagram.com/v/t51.82787-15/684122119_17948615151160369_8579768705782264314_n.jpg?stp=dst-jpg_e35_tt6&_nc_cat=105&ccb=7-5&_nc_sid=18de74&efg=eyJlZmciOiJDTElQUy5pZ19zaGltX3JlYWQuNTQweDk2MC5DMyJ9&_nc_ohc=D8nWDrnuCD0Q7kNvwG7sIJp&_nc_oc=AdroHQTT9tOHu0oJKD7UwUmxe9YU64TmxoewCwWx0knWaPqIpar9iMcu4-YFZRVqPa0UeoV7siHHVH0l6CpcjeNW&_nc_zt=23&_nc_ht=scontent.cdninstagram.com&_nc_gid=xAEe4R1VlZsHc6ydNAq95w&_nc_ss=7b6a8&oh=00_Af4rh5YRxHXRPvUFWW3I4ibHPn02Ql7V3TaZuMllf7zdyQ&oe=6A1A2C69&ig_cache_key=Mzg4ODE2MjI0MTU5Nzc0OTM2OQ%3D%3D.2-ccb7-5' },
            { url: 'https://www.instagram.com/p/DXDFg1Wjo2j/', type: 'ig', title: 'Reason #627 how @multisellerpro is going to save you time', thumbUrl: 'https://scontent.cdninstagram.com/v/t51.71878-15/670306932_865148956616301_8039021499820050752_n.jpg?stp=dst-jpg_e35_tt6&_nc_cat=102&ccb=7-5&_nc_sid=18de74&efg=eyJlZmciOiJDTElQUy5pZ19zaGltX3JlYWQuNjQweDExMzYuQzMifQ%3D%3D&_nc_ohc=96NLitL1lScQ7kNvwGcpNCK&_nc_oc=Adod6k-GL5hp6a5iXV0c_J7B1go2NXvRw52WjemydNyw-E4z_5SRzGzOCtTZSYwjD1e96Vox4VilDd0VXXrXFwOA&_nc_zt=23&_nc_ht=scontent.cdninstagram.com&_nc_gid=xAEe4R1VlZsHc6ydNAq95w&_nc_ss=7b6a8&oh=00_Af6nMDUnF7GNoBwVRG1Fv8kXVlwS9UmSmZvF2ZwUQF8aug&oe=6A1A492D&ig_cache_key=Mzg3Mzk2NDM1MTAxMTMyNzM5NQ%3D%3D.2-ccb7-5' },
            { url: 'https://www.instagram.com/p/DXITkwHjnaW/', type: 'ig', title: 'How @multisellerpro is going to save you time with your aip product reviews', thumbUrl: 'https://scontent.cdninstagram.com/v/t51.71878-15/671138340_1250020696951726_4168692692966091006_n.jpg?stp=dst-jpg_e35_tt6&_nc_cat=100&ccb=7-5&_nc_sid=18de74&efg=eyJlZmciOiJDTElQUy5pZ19zaGltX3JlYWQuNjQweDExMzYuQzMifQ%3D%3D&_nc_ohc=uGiBApgRaywQ7kNvwHPHe1o&_nc_oc=AdociLx0hUkSN_-jCPziqF8PlVDTPIcEeBvWtLh48JRrYPQkH8fiBMGU7ck_yl1vnBzlVTFEVImxaEswo3KBt1_I&_nc_zt=23&_nc_ht=scontent.cdninstagram.com&_nc_gid=tqBxhEV85KM7vfGbNaI6wQ&_nc_ss=7b6a8&oh=00_Af53dhLzymMgLL0vijXkYTbAmaX-NtDZHPKFWndLNLnRcg&oe=6A1A22F0&ig_cache_key=Mzg3NTQzMzU2NzgwMzU2OTgxNA%3D%3D.2-ccb7-5' },
            { url: 'https://www.instagram.com/p/DXAk4p8Dm2Q/', type: 'ig', title: 'One of the coolest features that we have', thumbUrl: 'https://scontent.cdninstagram.com/v/t51.71878-15/669838970_1285384973555377_5224942559034462760_n.jpg?stp=dst-jpg_e35_tt6&_nc_cat=108&ccb=7-5&_nc_sid=18de74&efg=eyJlZmciOiJDTElQUy5pZ19zaGltX3JlYWQuNjQweDExMzYuQzMifQ%3D%3D&_nc_ohc=ImWTqnmydLoQ7kNvwG2I5y8&_nc_oc=AdpCvx3tBmGXx30EODYYLOY21vtWeH15DRL6KceVXCp3u6hrFSZkigxg0v3xSMkDbESV050hsb8lz9idBlG4G9Bb&_nc_zt=23&_nc_ht=scontent.cdninstagram.com&_nc_gid=xAEe4R1VlZsHc6ydNAq95w&_nc_ss=7b6a8&oh=00_Af5Dbs1StpjqA_NJgef8BfmQyMEqLV3Dkknehd0FNG81bA&oe=6A1A3091&ig_cache_key=Mzg3MzI1NzkwMjUzNDcxNjgxNg%3D%3D.2-ccb7-5' },
            { url: 'https://www.instagram.com/p/DWKgdiIDgAV/', type: 'ig', title: 'Here\'s a peak at one of @multisellerpro features', thumbUrl: 'https://scontent.cdninstagram.com/v/t51.82787-15/655908235_17942530878160369_2193865785010454929_n.jpg?stp=dst-jpg_e35_tt6&_nc_cat=110&ccb=7-5&_nc_sid=18de74&efg=eyJlZmciOiJDTElQUy5pZ19zaGltX3JlYWQuNzIweDEyODAuQzMifQ%3D%3D&_nc_ohc=epwb-H__vscQ7kNvwESoi-n&_nc_oc=Adr1RSV9qSwG_gTJ-8ZBu6_be_ODSI9Yn0vjB-Kth3PlzO7zvVjFLUSLIskrRCAnPA34zuE8oznVQST4J6OZ0hmF&_nc_zt=23&_nc_ht=scontent.cdninstagram.com&_nc_gid=xAEe4R1VlZsHc6ydNAq95w&_nc_ss=7b6a8&oh=00_Af51wbdqbq4OG0wNeihVkeCdB_ICnpfR6aIoBBc6U_H6Vw&oe=6A1A23E8&ig_cache_key=Mzg1ODAzODc5Nzc5MTc4OTA3Nw%3D%3D.2-ccb7-5' },
            { url: 'https://www.instagram.com/p/DWUyaSijFzL/', type: 'ig', title: 'AIP influencers - Multi Seller Pro has your back!', thumbUrl: 'https://scontent.cdninstagram.com/v/t51.82787-15/657910183_17853085224689611_7238695176828357248_n.jpg?stp=dst-jpg_e35_tt6&_nc_cat=107&ccb=7-5&_nc_sid=18de74&efg=eyJlZmciOiJDTElQUy5pZ19zaGltX3JlYWQuMTA4MHgxOTIwLkMzIn0%3D&_nc_ohc=4G7dOQKDflkQ7kNvwG3M9J4&_nc_oc=AdqrV5DEsYx6vGjZLm5i3Oy5ITz9MvTln7pc2rTRk16VLP2GmwAMhpq8M1OIoBnts1ICX03GQ_zFKTnoQ7Tn7dhD&_nc_zt=23&_nc_ht=scontent.cdninstagram.com&_nc_gid=xAEe4R1VlZsHc6ydNAq95w&_nc_ss=7b6a8&oh=00_Af4-UXludF997hC2n0PGRefWzFYXhj8wZxwVq0-okKUGLg&oe=6A1A3AA2&ig_cache_key=Mzg2MDkzMjQ4OTUwMjI4NTAwMw%3D%3D.2-ccb7-5' },
        ],
        videos: [
            { url: 'https://www.youtube.com/embed/IPUaFKLJX50', title: 'Going over Amazon influencer program (AIP) Q and A for beginners' },
        ],
    },
    {
        id: 'nate',
        name: 'Nate Jackson',
        photo: '/hium/nate.jpeg',
        description: 'Nate Jackson from Hustle Buddies!',
        links: [
            { label: 'YouTube', icon: 'youtube', url: 'https://www.youtube.com/@HustleBuddiesOfficial' },
            { label: 'Instagram', icon: 'instagram', url: 'https://www.facebook.com/groups/HustleBuddies' },
        ],
        accentColor: '#0ba82d',
        shorts: [],
        videos: [
            { url: 'https://www.youtube.com/embed/h5-A1ZTKXGY', title: 'How to Master Amazon Influencer Research with Multi-Influencer Pro' },
            { url: 'https://www.youtube.com/embed/zUDB1JwnCY4', title: 'A Day in the Life: Amazon Influencer Filming' },
            { url: 'https://www.youtube.com/embed/ICIfbLaPNzs', title: 'Amazon Influencer Tutorials - MIP - In App Recording.' },
            { url: 'https://www.youtube.com/embed/qm0HhmVpQ1g', title: 'Amazon Influencers - Multi Influencer Pro Tutorial - The App' },
            { url: 'https://www.youtube.com/embed/QLLtqogs1No', title: 'I tested the tool replacing ALL' },
            { url: 'https://www.youtube.com/embed/_cWHXqf8eQ0', title: 'The #1 highest income producing task for Amazon Influencers' },
            { url: 'https://www.youtube.com/embed/ZxLDWssa3jI', title: 'Amazon Influencers - New influencer tool. First look!' },
            { url: 'https://www.youtube.com/embed/SABDDD6nmvg', title: 'Amazon Influencers Are Using This Free Thumbnail Trick' },
            { url: 'https://www.youtube.com/embed/rHCqo5WJd3w', title: 'Bin Store Hunting for Amazon Influencers!' },
            { url: 'https://www.youtube.com/embed/FSnj0vZISNw', title: 'Amazon Influencer International Storefront Setup (Step-by-Step)' },
            { url: 'https://www.youtube.com/embed/uolS-6gJ7MU', title: 'Amazon Influencer Program - FOOL PROOF way to get accepted' },
            { url: 'https://www.youtube.com/embed/Rh2vy_oPwKU', title: 'HOW TO GET ACCEPTED INTO THE AMAZON INFLUENCER PROGRAM - 2026' },
            { url: 'https://www.youtube.com/embed/1Cytl8tqtc8', title: 'Amazon Influencer - How to get your 3 videos APPROVED' },
        ],
    },
    {
        id: 'tracey',
        name: 'Tracey Shelley',
        marketplaces: ['amazon', 'walmart', 'ebay'],
        photo: '/hium/tracey.jpeg',
        description: 'Dr. Tracey Shelley has been selling online for the past 30 years on eBay, Amazon, and Walmart.  She has worked with numerous sellers to help them build their businesses.  She has developed the WOW: Winning on Walmart brand to specifically help sellers succeed on Walmart.',
        services: 'Information on courses and paid services can be found at Linktree.',
        links: [
            { label: 'Linktree', icon: 'linktree', url: 'https://linktr.ee/7figuregrammy' },
            { label: 'Instagram', icon: 'instagram', url: 'https://www.instagram.com/7figuregrammy/' },
            { label: 'YouTube', icon: 'youtube', url: 'https://www.youtube.com/@7figuregrammy77' },
            { label: 'TikTok', icon: 'tiktok', url: 'https://www.tiktok.com/@wowwinningonwm' },
            { label: 'X.com', icon: 'x', url: 'https://x.com/7figuregrammy' },
        ],
        accentColor: '#2563eb',
        shorts: [],
        videos: [
            { url: 'https://www.youtube.com/embed/m5aLS52HXWM', title: 'How to Find the BEST Creator Connections Campaigns for YOU!' },
            { url: 'https://www.youtube.com/embed/PyC8_lFp1Uo', title: 'Scan Items with your Phone and Know if they have a Creator Connections Campaign' },
            { url: 'https://www.youtube.com/embed/s5izTdfrj50', title: '10x Your Video Output for Amazon Influencer Program' },
        ],
    },
    {
        id: 'ido',
        name: 'Ido Friedman',
        photo: '/hium/ido.jpeg',
        description: 'Passionate programmer since age 10. Now building MultiSellerPro. Always pushing the boundaries of technology to solve real-world problems and create impactful solutions that deliver FAST results that online sellers can benefit from IMMEDIATELY.',
        links: [
            { label: 'YouTube', icon: 'youtube', url: 'https://www.youtube.com/@MultiSellerPro' },
            { label: 'Instagram', icon: 'instagram', url: 'https://www.instagram.com/idofriedman9/' },
            { label: 'Facebook', icon: 'facebook', url: 'https://www.facebook.com/groups/multisellerpro/' },
        ],
        accentColor: '#0d9488',
        shorts: [
            { url: 'https://www.instagram.com/p/DZiOY4atgQG/', type: 'ig', title: 'The Best Mobile App!' },
            { url: 'https://www.youtube.com/embed/ajtFRHEAZ_Y', type: 'yt', title: 'Tip #1' },
            { url: 'https://www.youtube.com/embed/S2zD3I7ajdQ', type: 'yt', title: 'Tip #1' },
            { url: 'https://www.youtube.com/embed/hsKD8dIDMV8', type: 'yt', title: 'Tip #1' },
            { url: 'https://www.youtube.com/embed/W15olK5VCwE', type: 'yt', title: 'Tip #1' },
            { url: 'https://www.instagram.com/p/DYdbMrAImWz/', type: 'ig', title: 'Multi Influencer Pro is literally magic!', thumbUrl: 'https://scontent.cdninstagram.com/v/t51.71878-15/700692126_2900855956921733_6393769647516339743_n.jpg?stp=cmp1_dst-jpg_e35_s640x640_tt6&_nc_cat=101&ccb=7-5&_nc_sid=18de74&efg=eyJlZmdfdGFnIjoiQ0xJUFMuYmVzdF9pbWFnZV91cmxnZW4uQzMifQ%3D%3D&_nc_ohc=WClkRkrJw-cQ7kNvwEmmu_b&_nc_oc=Adomgn_NLByCslYYfwObTg5WjQcZRwoTkYXcjo79J8zI9JYny7pNKzoMjmObkjg14y963YKzpln7FWtzZbKscHM_&_nc_zt=23&_nc_ht=scontent.cdninstagram.com&_nc_gid=zjwFMnzuexNEBdzRYHL-fw&_nc_ss=7b6a8&oh=00_Af5Md3rqLru-kEonbxzXn6BEgM-oM2qGuC_211PftQHfew&oe=6A1A26A2' },
            { url: 'https://www.instagram.com/p/DYLG4X-uTh7/', type: 'ig', title: 'The best tool for AIP creators is out!', thumbUrl: 'https://scontent.cdninstagram.com/v/t51.82787-15/695705259_17860849545689611_1092214828277296006_n.jpg?stp=cmp1_dst-jpg_e35_s640x640_tt6&_nc_cat=111&ccb=7-5&_nc_sid=18de74&efg=eyJlZmdfdGFnIjoiQ0xJUFMuYmVzdF9pbWFnZV91cmxnZW4uQzMifQ%3D%3D&_nc_ohc=hxH4Xk_BbVoQ7kNvwE6iMBq&_nc_oc=AdojzbZILjIwo0vGka70ZZBLlgxq6M73F9chm_l4Eb9j03kYrCHmKHte2fyrmfIVSW68fFWmw27oyq7wjnoNlh20&_nc_zt=23&_nc_ht=scontent.cdninstagram.com&_nc_gid=5y8w32mkdpR9UTQAjdDBMA&_nc_ss=7b6a8&oh=00_Af5z2oCZaQsaGW9_wjD6rmPx9Skzua3UFNRPOSfoF0ceOg&oe=6A1A347D' },
            { url: 'https://www.instagram.com/p/DYIVMyDud4W/', type: 'ig', title: 'Another crazy feature MSP has!', thumbUrl: 'https://scontent.cdninstagram.com/v/t51.82787-15/694662601_17860664457689611_4425133019962090011_n.jpg?stp=cmp1_dst-jpg_e35_s640x640_tt6&_nc_cat=107&ccb=7-5&_nc_sid=18de74&efg=eyJlZmdfdGFnIjoiQ0xJUFMuYmVzdF9pbWFnZV91cmxnZW4uQzMifQ%3D%3D&_nc_ohc=IDUUQvEgvokQ7kNvwFyADFc&_nc_oc=AdoxivmI6uQbPgQgJeuC3Dd7mjECGUW_TuvNOkVUcFz12boFsTwy2Lo2tvxd6PiI_5cSvJNTopO8dmYWpgGNOZv2&_nc_zt=23&_nc_ht=scontent.cdninstagram.com&_nc_gid=M5g9bf_B1LXKilERrV9N5A&_nc_ss=7b6a8&oh=00_Af7rCM3teXn1MtQRik87KqtS0K7OW8gXv041JgH4_-i5sA&oe=6A1A4343' },
        ],
        videos: [
            { url: 'https://www.youtube.com/embed/kgTFxilp08Q', title: 'Storefront Health Check' },
            { url: 'https://www.youtube.com/embed/Q8rke6iSrgw', title: 'Accepting Campaigns, Submitting Links, and More' },
            { url: 'https://www.youtube.com/embed/ozrozDrVt5k', title: 'The Message System' },
            { url: 'https://www.youtube.com/embed/cWG7prQKKvQ', title: 'Doing Product Research' },
            { url: 'https://www.youtube.com/embed/ODu8CIi5n4o', title: 'Finding Your First Products' },
            { url: 'https://www.youtube.com/embed/duEqOPF7z6Y', title: 'Upload/Post a Review' },
            { url: 'https://www.youtube.com/embed/bTajnIH05oM', title: 'Record A Video' },
            { url: 'https://www.youtube.com/embed/zpqdz1KCPGY', title: 'I increased my monthly revenue just by using the MIP Storefront Healer!' },
            { url: 'https://www.youtube.com/embed/KNYJSN8Wk1Q', title: 'Another big update to MIP 2.0! WE WILL NOT STOP!' },
            { url: 'https://www.youtube.com/embed/DtfZyA_uHE4', title: 'More MIP 2.0 Updates!!' },
            { url: 'https://www.youtube.com/embed/ho3i0pql6V0', title: 'Week of MIP 2.0 updates!' },
            { url: 'https://www.youtube.com/embed/tDmkfvPl7lg', title: 'Power Search 2.0 + Message System Updates!' },
            { url: 'https://www.youtube.com/embed/aoCynpyxDJ4', title: 'How to Create Comparison Videos for AIP Using MIP' },
            { url: 'https://www.youtube.com/embed/7qZY5Hw3GKI', title: 'Another Amazing Feature You Requested Is LIVE! (Influencer Pro)' },
            { url: 'https://www.youtube.com/embed/x8EmexOKX2A', title: 'How To Use MIP Message System for AIP Creator Connections' },
            { url: 'https://www.youtube.com/embed/B80DAhD5Cfw', title: '11 Minutes That Could Change Your AIP Forever' },
            { url: 'https://www.youtube.com/embed/iTzNGORnobs', title: 'AIP Text To Thumbnail' },
            { url: 'https://www.youtube.com/embed/ODm0tMvvdeI', title: 'Auto AIP Upload to YouTube & List on eBay' },
        ],
    },
    {
        id: 'rafaella',
        name: 'Rafaella',
        photo: '/hium/rafaella.png',
        description: 'I\'m Rafaella, a 6-figure Amazon reseller and coach documenting my journey to building a $100,000/month Amazon business.',
        links: [
            { label: 'Instagram', icon: 'instagram', url: 'https://www.instagram.com/rafaellasells/' },
            { label: 'YouTube', icon: 'youtube', url: 'https://www.youtube.com/@rafaellasells' },
        ],
        accentColor: '#d1ce14',
        shorts: [],
        videos: [
            { url: 'https://www.youtube.com/embed/hqPzxdziAa0', title: 'How to use MultiSellerPro for AIP Brand Outreach' },
            { url: 'https://www.youtube.com/embed/tk8gcYoYAyw', title: 'Using MultisellerPro to Bulk Message Brands' },
            { url: 'https://www.youtube.com/embed/guAQnVMbKos', title: 'Storefront Stalking with MultiSellerPro' },
        ],
    },
    {
        id: 'mike',
        name: 'Michael Morejon',
        photo: '/hium/mike.jpg',
        description: 'Full-time content creator, Amazon Influencer, and eCommerce reseller. Mike and his wife Jaqueline have produced 2,000+ product review videos across 4 AIP storefronts (US, CA, UK, AU) and generated over $2M in Amazon sales. Also active on eBay and Walmart, with 100+ UGC brand deals completed across platforms.',
        services: "UGC content creation (English & Spanish) · Amazon Influencer reviews · Brand partnerships · eBay & Walmart reselling",
        links: [
            { label: 'Instagram', icon: 'instagram', url: 'https://www.instagram.com/createwithmike305/' },
            { label: 'X', icon: 'x', url: 'https://x.com/Ecom_305' },
            { label: 'TikTok', icon: 'tiktok', url: 'https://www.tiktok.com/@ecom_305' },
        ],
        accentColor: '#0d9488',
        shorts: [
            { url: 'https://www.instagram.com/p/DaBRub_R0Kb/', type: 'ig', title: 'This tool has improved how we upload videos to Amazon influencer' },
            { url: 'https://www.instagram.com/p/DYU10tqxCJI/', type: 'ig', title: 'Video Studio', thumbUrl: 'https://scontent.cdninstagram.com/v/t51.71878-15/672370393_1334193605268684_1457939816366888123_n.jpg?stp=cmp1_dst-jpg_e35_s640x640_tt6&_nc_cat=106&ccb=7-5&_nc_sid=18de74&efg=eyJlZmdfdGFnIjoiQ0xJUFMuYmVzdF9pbWFnZV91cmxnZW4uQzMifQ%3D%3D&_nc_ohc=K-aLVBSbzMgQ7kNvwGCQ5lx&_nc_oc=AdrvqXjYs6KgNdB6qIp2ZBkwfNJHH9CnnuIx760U_4GJFbDhCuLiTkPjFCv1RtXhkAtgYZiEUcE4npeDH5X6ifRL&_nc_zt=23&_nc_ht=scontent.cdninstagram.com&_nc_gid=fcHKxkEzoh0VBU7AB0H2lg&_nc_ss=7b6a8&oh=00_Af7QacaD5ZgjMW6NSi_9462PC4GOp3QoxI7xcjE19z-ULA&oe=6A1BBBF9' },
            { url: 'https://www.instagram.com/p/DXvZ4vrOhQ_/', type: 'ig', title: 'Extension Data', thumbUrl: 'https://scontent.cdninstagram.com/v/t51.71878-15/682886413_1226263272718596_8758467000509412181_n.jpg?stp=cmp1_dst-jpg_e35_s640x640_tt6&_nc_cat=108&ccb=7-5&_nc_sid=18de74&efg=eyJlZmdfdGFnIjoiQ0xJUFMuYmVzdF9pbWFnZV91cmxnZW4uQzMifQ%3D%3D&_nc_ohc=VNzyp1sLoLsQ7kNvwHrYZGw&_nc_oc=AdrORjI32P2LMMXIO6dqYdi9VFn8HSijiCXXzJpU1zLupeNvAi9dG0y2SrCfLe7DnRf55y7oibh0O5MWwret-A80&_nc_zt=23&_nc_ht=scontent.cdninstagram.com&_nc_gid=NSQlHIN8V0vjzZmeoScAbg&_nc_ss=7b6a8&oh=00_Af7AiODNdwK45P4bBtvqLpaEsHJglHSarvJdeak8T_dGeg&oe=6A1BC733' },
            { url: 'https://www.instagram.com/p/DXZrgOAEVag/', type: 'ig', title: 'Video Studio', thumbUrl: 'https://scontent.cdninstagram.com/v/t51.71878-15/670898817_1350499133586117_276360107372825860_n.jpg?stp=cmp1_dst-jpg_e35_s640x640_tt6&_nc_cat=109&ccb=7-5&_nc_sid=18de74&efg=eyJlZmdfdGFnIjoiQ0xJUFMuYmVzdF9pbWFnZV91cmxnZW4uQzMifQ%3D%3D&_nc_ohc=FZOdeLiBIooQ7kNvwGPVj0n&_nc_oc=AdrP9BhuK-GgQLid5eHa0dQ1Zuh9kGdQUeJBkqXwNRlhrmQukF6fkXmIfy9ka2F95kUKaGZsYt3qx3PYk_ebYvBz&_nc_zt=23&_nc_ht=scontent.cdninstagram.com&_nc_gid=KSnQNvYlOK1auLFugo_mJA&_nc_ss=7b6a8&oh=00_Af5JMj7knl4GA_QCMQNGZzHjlJNZ7jrIhr6B2diThinD3Q&oe=6A1BBB08' },
        ],
        videos: [
        ],
    },
];

/* ═══════════════════════════════════════════════════════════════
   MERCH MILESTONES
═══════════════════════════════════════════════════════════════ */
const MERCH_MILESTONES = [
    { at: 5, img: 'hat.png', label: 'Hat', color: '#f59e0b' },
    { at: 10, img: 'tshirt.png', label: 'T-Shirt', color: '#10b981' },
    { at: 20, img: 'hoodie.png', label: 'Hoodie', color: '#6366f1' },
    { at: 30, img: 'mystery.png', label: 'Mystery', color: '#ec4899' },
];

/* ═══════════════════════════════════════════════════════════════
   LOCAL STORAGE HELPERS
═══════════════════════════════════════════════════════════════ */
const LS_KEY = 'msp_hium_v1';

const loadStorage = () => {
    try {
        const raw = localStorage.getItem(LS_KEY);
        return raw ? JSON.parse(raw) : { watched: {}, favorites: {}, notes: {}, creatorFavorites: {} };
    } catch { return { watched: {}, favorites: {}, notes: {}, creatorFavorites: {} }; }
};

const saveStorage = (data) => {
    try { localStorage.setItem(LS_KEY, JSON.stringify(data)); } catch { }
};

const useUserData = () => {
    const [data, setData] = useState(loadStorage);

    const update = useCallback((updater) => {
        setData(prev => {
            const next = updater({ ...prev });
            saveStorage(next);
            return next;
        });
    }, []);

    const toggleWatched = useCallback((videoKey) => {
        update(d => {
            if (d.watched[videoKey]) delete d.watched[videoKey];
            else d.watched[videoKey] = Date.now();
            return d;
        });
    }, [update]);

    const toggleFavorite = useCallback((videoKey) => {
        update(d => {
            if (d.favorites[videoKey]) delete d.favorites[videoKey];
            else d.favorites[videoKey] = Date.now();
            return d;
        });
    }, [update]);

    const setNote = useCallback((videoKey, text) => {
        update(d => {
            if (!text.trim()) delete d.notes[videoKey];
            else d.notes[videoKey] = text;
            return d;
        });
    }, [update]);

    const toggleCreatorFavorite = useCallback((creatorKey) => {
        update(d => {
            if (d.creatorFavorites[creatorKey]) delete d.creatorFavorites[creatorKey];
            else d.creatorFavorites[creatorKey] = Date.now();
            return d;
        });
    }, [update]);

    return { data, toggleWatched, toggleFavorite, setNote, toggleCreatorFavorite };
};

/* ═══════════════════════════════════════════════════════════════
   VIDEO KEY HELPER
═══════════════════════════════════════════════════════════════ */
const videoKey = (creatorId, tab, videoUrl) => `${tab}::${creatorId}::${videoUrl}`;

/* ═══════════════════════════════════════════════════════════════
   MERCH PROGRESS BAR
═══════════════════════════════════════════════════════════════ */
const MerchProgressBar = ({ total, accentColor }) => {
    const maxMilestone = MERCH_MILESTONES[MERCH_MILESTONES.length - 1].at;
    const capped = Math.min(total, maxMilestone);
    const pct = maxMilestone > 0 ? (capped / maxMilestone) * 100 : 0;

    return (
        <div style={{ margin: '12px 0 4px' }}>
            <div style={{ position: 'relative', marginBottom: 8 }}>
                <div style={{
                    position: 'absolute', top: '50%', left: 0, right: 0,
                    height: 4, background: '#e5e7eb', borderRadius: 4,
                    transform: 'translateY(-50%)', zIndex: 0,
                }} />
                <div style={{
                    position: 'absolute', top: '50%', left: 0,
                    height: 4, background: `linear-gradient(90deg, ${accentColor}88, ${accentColor})`,
                    borderRadius: 4, transform: 'translateY(-50%)',
                    width: `${pct}%`, transition: 'width 0.6s ease', zIndex: 1,
                }} />
                <div style={{ display: 'flex', justifyContent: 'space-between', position: 'relative', zIndex: 2 }}>
                    {MERCH_MILESTONES.map((m) => {
                        const reached = total >= m.at;
                        return (
                            <div key={m.at} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 3 }}>
                                <div style={{
                                    width: 36, height: 36, borderRadius: '50%',
                                    background: '#fff',
                                    border: `2px solid ${reached ? m.color : '#d1d5db'}`,
                                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                                    boxShadow: reached ? `0 0 0 3px ${m.color}22` : 'none',
                                    transition: 'all 0.3s ease', overflow: 'hidden',
                                    opacity: reached ? 1 : 0.5, padding: 5,
                                }}>
                                    <img src={`/merch/${m.img}`} alt={m.label} style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                {MERCH_MILESTONES.map((m) => {
                    const reached = total >= m.at;
                    return (
                        <div key={m.at} style={{ textAlign: 'center', minWidth: 42 }}>
                            <div style={{ fontSize: 9.5, fontWeight: 700, color: reached ? m.color : '#9ca3af', letterSpacing: '0.02em' }}>{m.label}</div>
                            <div style={{ fontSize: 9, color: '#9ca3af' }}>{m.at} vids</div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

/* ═══════════════════════════════════════════════════════════════
   HELPERS
═══════════════════════════════════════════════════════════════ */
const TikTokIcon = ({ size = 13 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
        <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-2.88 2.5 2.89 2.89 0 01-2.89-2.89 2.89 2.89 0 012.89-2.89c.28 0 .54.04.79.1V9.01a6.33 6.33 0 00-.79-.05 6.34 6.34 0 00-6.34 6.34 6.34 6.34 0 006.34 6.34 6.34 6.34 0 006.33-6.34V8.69a8.18 8.18 0 004.79 1.53V6.78a4.84 4.84 0 01-1.02-.09z" />
    </svg>
);

const XIcon = createLucideIcon("X", [
    ["path", { d: "M18.901 1.153h3.68l-8.04 9.19L24 22.846h-7.406l-5.8-7.584-6.638 7.584H.474l8.6-9.83L0 1.154h7.594l5.243 6.932ZM17.61 20.644h2.039L6.486 3.24H4.298Z", stroke: "none", fill: "currentColor" }],
]);

const LinkIcon = ({ icon, size = 13 }) => {
    if (icon === 'youtube') return <Youtube size={size} />;
    if (icon === 'instagram') return <Instagram size={size} />;
    if (icon === 'x') return <XIcon size={size} />;
    if (icon === 'facebook') return <Facebook size={size + 2} />;
    if (icon === 'tiktok') return <TikTokIcon size={size} />;
    return <Globe size={size} />;
};

/* ═══════════════════════════════════════════════════════════════
   INSTAGRAM REEL CARD
═══════════════════════════════════════════════════════════════ */
const IgReelCard = ({ short }) => {
    const [thumbUrl, setThumbUrl] = React.useState(null);

    React.useEffect(() => {
        if (thumbUrl) return;
        fetch(`https://server.multisellerpro.com/hium/thumbnail?url=${encodeURIComponent(short.url)}`)
            .then(r => r.json())
            .then(data => { if (data.thumb) setThumbUrl(data.thumb); })
            .catch(() => { });
    }, [short.url]);

    return (
        <a
            href={short.url} target="_blank" rel="noopener noreferrer"
            style={{
                flexShrink: 0, width: 200, height: 356, borderRadius: 14, overflow: 'hidden',
                border: '1px solid #e5e7eb', display: 'block', position: 'relative',
                background: thumbUrl ? '#000' : 'linear-gradient(160deg, #833ab4 0%, #fd1d1d 50%, #fcb045 100%)',
                textDecoration: 'none', cursor: 'pointer',
            }}
        >
            {thumbUrl && (
                <img src={thumbUrl} alt={short.title} style={{ width: '100%', height: '100%', objectFit: 'cover', opacity: 0.82 }} />
            )}
            <div style={{ position: 'absolute', inset: 0, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 8 }}>
                <div style={{ width: 46, height: 46, borderRadius: '50%', background: 'rgba(0,0,0,0.52)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {thumbUrl ? <Play size={20} fill="#fff" color="#fff" /> : <ExternalLink size={17} color="#fff" />}
                </div>
                {!thumbUrl && <span style={{ color: '#fff', fontSize: 12, fontWeight: 600 }}>{short.title || 'Open Reel'}</span>}
            </div>
            <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, background: 'linear-gradient(to top, rgba(0,0,0,0.75), transparent)', padding: '28px 10px 10px' }}>
                <p style={{ color: '#fff', fontSize: 11, fontWeight: 600, margin: 0, textAlign: 'center' }}>{short.title}</p>
            </div>
        </a>
    );
};

/* ═══════════════════════════════════════════════════════════════
   VIDEO CARD (with watch/favorite/note)
═══════════════════════════════════════════════════════════════ */
const VideoCard = ({ video, vKey, userData, onToggleWatched, onToggleFavorite, onSetNote, accentColor }) => {
    const [noteOpen, setNoteOpen] = useState(false);
    const [noteText, setNoteText] = useState(userData.notes[vKey] || '');
    const isWatched = !!userData.watched[vKey];
    const isFav = !!userData.favorites[vKey];
    const hasNote = !!userData.notes[vKey];

    const handleNoteBlur = () => { onSetNote(vKey, noteText); };
    const handleNoteKeyDown = (e) => {
        if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); onSetNote(vKey, noteText); setNoteOpen(false); }
        if (e.key === 'Escape') setNoteOpen(false);
    };

    return (
        <div style={{
            borderRadius: 12, overflow: 'visible', background: '#fff',
            border: `1px solid ${isWatched ? '#d1fae5' : '#e5e7eb'}`,
            boxShadow: isWatched ? '0 0 0 2px #d1fae511' : 'none',
            position: 'relative', transition: 'border-color 0.2s',
        }}>
            {!isWatched && (
                <div style={{
                    position: 'absolute', top: -8, left: 12, zIndex: 3,
                    background: '#ef4444', color: '#fff', fontSize: 9, fontWeight: 800,
                    padding: '2px 7px', borderRadius: 20, letterSpacing: '0.06em',
                    boxShadow: '0 2px 8px #ef444444',
                }}>NEW</div>
            )}
            <div style={{ aspectRatio: '16/9', background: '#000', borderRadius: '11px 11px 0 0', overflow: 'hidden' }}>
                <iframe
                    src={`${video.url}?rel=0`} title={video.title} frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen style={{ width: '100%', height: '100%', display: 'block' }}
                />
            </div>
            <div style={{ background: '#fff', padding: '10px 12px 8px', borderTop: '1px solid #f0f0f0' }}>
                <p style={{
                    fontSize: 13, fontWeight: 600, color: isWatched ? '#6b7280' : '#374151',
                    margin: '0 0 8px', overflow: 'hidden', textOverflow: 'ellipsis',
                    display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical',
                    textDecoration: isWatched ? 'line-through' : 'none', textDecorationColor: '#9ca3af',
                }}>{video.title}</p>
                <div style={{ display: 'flex', gap: 6, alignItems: 'center', flexWrap: 'wrap' }}>
                    <button onClick={() => onToggleWatched(vKey)} title={isWatched ? 'Mark as unwatched' : 'Mark as watched'} style={{
                        display: 'inline-flex', alignItems: 'center', gap: 4,
                        padding: '4px 9px', borderRadius: 20, fontSize: 11, fontWeight: 600,
                        border: isWatched ? '1px solid #6ee7b744' : '1px solid #e5e7eb',
                        background: isWatched ? '#d1fae5' : '#f9fafb',
                        color: isWatched ? '#059669' : '#6b7280',
                        cursor: 'pointer', transition: 'all 0.2s',
                    }}>
                        {isWatched ? <Check size={10} /> : <Eye size={10} />}
                        {isWatched ? 'Watched' : 'Unwatched'}
                    </button>
                    <button onClick={() => onToggleFavorite(vKey)} title={isFav ? 'Remove favorite' : 'Save as favorite'} style={{
                        display: 'inline-flex', alignItems: 'center', gap: 4,
                        padding: '4px 9px', borderRadius: 20, fontSize: 11, fontWeight: 600,
                        border: isFav ? '1px solid #fde68a' : '1px solid #e5e7eb',
                        background: isFav ? '#fef9c3' : '#f9fafb',
                        color: isFav ? '#d97706' : '#6b7280',
                        cursor: 'pointer', transition: 'all 0.2s',
                    }}>
                        {isFav ? <BookmarkCheck size={10} /> : <Bookmark size={10} />}
                        {isFav ? 'Saved' : 'Save'}
                    </button>
                    <button onClick={() => setNoteOpen(o => !o)} title="Add a note" style={{
                        display: 'inline-flex', alignItems: 'center', gap: 4,
                        padding: '4px 9px', borderRadius: 20, fontSize: 11, fontWeight: 600,
                        border: hasNote ? `1px solid ${accentColor}44` : '1px solid #e5e7eb',
                        background: hasNote ? `${accentColor}12` : '#f9fafb',
                        color: hasNote ? accentColor : '#6b7280',
                        cursor: 'pointer', transition: 'all 0.2s',
                    }}>
                        <StickyNote size={10} />
                        {hasNote ? 'Note ✓' : 'Note'}
                    </button>
                </div>
                {noteOpen && (
                    <div style={{ marginTop: 8 }}>
                        <textarea
                            autoFocus value={noteText}
                            onChange={e => setNoteText(e.target.value)}
                            onBlur={handleNoteBlur} onKeyDown={handleNoteKeyDown}
                            placeholder="Add your note… (Enter to save, Esc to close)"
                            rows={2}
                            style={{
                                width: '100%', padding: '7px 10px', borderRadius: 8,
                                border: `1px solid ${accentColor}44`, fontSize: 12,
                                color: '#374151', background: `${accentColor}08`,
                                outline: 'none', resize: 'vertical', fontFamily: 'inherit',
                                boxSizing: 'border-box',
                            }}
                        />
                        {userData.notes[vKey] && (
                            <p style={{ fontSize: 10, color: '#9ca3af', margin: '3px 0 0', fontStyle: 'italic' }}>
                                Saved: "{userData.notes[vKey]}"
                            </p>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

/* ═══════════════════════════════════════════════════════════════
   MODAL
═══════════════════════════════════════════════════════════════ */
const Modal = ({ creator, tab, onClose, userData, onToggleWatched, onToggleFavorite, onSetNote }) => {
    const shortsRef = useRef(null);

    useEffect(() => {
        const handler = e => { if (e.key === 'Escape') onClose(); };
        window.addEventListener('keydown', handler);
        return () => window.removeEventListener('keydown', handler);
    }, [onClose]);

    const scrollShorts = dir => {
        if (shortsRef.current) shortsRef.current.scrollBy({ left: dir * 220, behavior: 'smooth' });
    };

    const initials = creator.name.split(' ').map(n => n[0]).join('');

    const SectionLabel = ({ text }) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 14 }}>
            <span style={{ width: 7, height: 7, borderRadius: '50%', background: creator.accentColor, flexShrink: 0, display: 'inline-block' }} />
            <span style={{ fontSize: 11, fontWeight: 700, color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.08em' }}>{text}</span>
        </div>
    );

    return (
        <div
            onClick={e => { if (e.target === e.currentTarget) onClose(); }}
            style={{
                position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)',
                zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20,
            }}
        >
            <div style={{
                background: '#fff', borderRadius: 20, width: '100%', maxWidth: 1180,
                maxHeight: '88vh', overflow: 'hidden', display: 'flex', flexDirection: 'column',
                border: '1px solid #e5e7eb',
            }}>
                <div style={{
                    padding: '18px 28px', borderBottom: '1px solid #f0f0f0',
                    display: 'flex', alignItems: 'center', gap: 14, flexShrink: 0,
                }}>
                    <div style={{
                        width: 44, height: 44, borderRadius: '50%', flexShrink: 0, overflow: 'hidden',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        background: creator.photo ? '#f3f4f6' : creator.accentColor,
                        border: `2.5px solid ${creator.accentColor}`,
                        color: '#fff', fontWeight: 600, fontSize: 15,
                    }}>
                        {creator.photo
                            ? <img src={creator.photo} alt={creator.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                            : initials}
                    </div>
                    <div style={{ flex: 1 }}>
                        <p style={{ fontWeight: 700, fontSize: 16, color: '#111', margin: 0 }}>{creator.name}</p>
                    </div>
                    <button onClick={onClose} aria-label="Close" style={{
                        width: 34, height: 34, borderRadius: 8, border: '1px solid #e5e7eb',
                        background: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center',
                        justifyContent: 'center', color: '#6b7280',
                    }}>
                        <X size={16} />
                    </button>
                </div>
                <div style={{ overflowY: 'auto', padding: 28, flex: 1 }}>
                    {creator.shorts?.length > 0 && (
                        <div style={{ marginBottom: 36 }}>
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 14 }}>
                                <SectionLabel text={`Shorts & Reels (${creator.shorts.length})`} />
                                <div style={{ display: 'flex', gap: 6 }}>
                                    {[ChevronLeft, ChevronRight].map((Icon, i) => (
                                        <button key={i} onClick={() => scrollShorts(i === 0 ? -1 : 1)} style={{
                                            width: 30, height: 30, borderRadius: '50%', border: '1px solid #e5e7eb',
                                            background: 'none', cursor: 'pointer', display: 'flex',
                                            alignItems: 'center', justifyContent: 'center', color: '#6b7280',
                                        }}>
                                            <Icon size={15} />
                                        </button>
                                    ))}
                                </div>
                            </div>
                            <div ref={shortsRef} style={{ display: 'flex', gap: 14, overflowX: 'auto', paddingBottom: 6 }}>
                                {creator.shorts.map((s, i) =>
                                    s.type === 'ig' ? (
                                        <IgReelCard key={i} short={s} />
                                    ) : (
                                        <div key={i} style={{
                                            flexShrink: 0, width: 200, height: 356, borderRadius: 14,
                                            overflow: 'hidden', background: '#000', border: '1px solid #e5e7eb',
                                        }}>
                                            <iframe
                                                src={`${s.url}?rel=0`} title={s.title} frameBorder="0"
                                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                                allowFullScreen style={{ width: '100%', height: '100%', display: 'block' }}
                                            />
                                        </div>
                                    )
                                )}
                            </div>
                        </div>
                    )}
                    {creator.videos?.length > 0 && (
                        <div>
                            <SectionLabel text={`Full Tutorials (${creator.videos.length})`} />
                            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))', gap: 16 }}>
                                {creator.videos.map((v, i) => {
                                    const vk = videoKey(creator.id, tab, v.url);
                                    return (
                                        <VideoCard
                                            key={i} video={v} vKey={vk} userData={userData}
                                            onToggleWatched={onToggleWatched} onToggleFavorite={onToggleFavorite}
                                            onSetNote={onSetNote} accentColor={creator.accentColor}
                                        />
                                    );
                                })}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

/* ═══════════════════════════════════════════════════════════════
   CREATOR CARD
═══════════════════════════════════════════════════════════════ */
const CreatorCard = ({ creator, tab, userData, onToggleWatched, onToggleFavorite, onSetNote, onToggleCreatorFavorite }) => {
    const [modalOpen, setModalOpen] = useState(false);
    const initials = creator.name.split(' ').map(n => n[0]).join('');
    const shortCount = creator.shorts?.length || 0;
    const videoCount = creator.videos?.length || 0;
    const totalVideos = shortCount + videoCount;
    const creatorKey = `${tab}::${creator.id}`;
    const isCreatorFav = !!userData.creatorFavorites[creatorKey];
    const watchedCount = creator.videos?.filter(v => !!userData.watched[videoKey(creator.id, tab, v.url)]).length || 0;

    return (
        <>
            <div style={{
                background: '#fff', borderRadius: 18, border: '1px solid #e5e7eb',
                overflow: 'hidden', borderTop: `4px solid ${creator.accentColor}`,
                outline: isCreatorFav ? `2px solid ${creator.accentColor}44` : 'none',
                outlineOffset: 2, transition: 'outline 0.2s',
            }}>
                <div style={{ padding: 24 }}>
                    <div style={{ display: 'flex', gap: 16, alignItems: 'flex-start' }}>
                        <div style={{
                            width: 72, height: 72, borderRadius: '50%', flexShrink: 0,
                            overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center',
                            background: creator.photo ? '#f3f4f6' : creator.accentColor,
                            border: `2.5px solid ${creator.accentColor}`,
                            color: '#fff', fontWeight: 700, fontSize: 22,
                        }}>
                            {creator.photo
                                ? <img src={creator.photo} alt={creator.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                : initials}
                        </div>
                        <div style={{ flex: 1, minWidth: 0 }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 2 }}>
                                <h2 style={{ fontSize: 18, fontWeight: 800, color: '#111', margin: 0, lineHeight: 1.3 }}>{creator.name}</h2>
                                <button
                                    onClick={() => onToggleCreatorFavorite(creatorKey)}
                                    title={isCreatorFav ? 'Remove from favorites' : 'Add to favorites'}
                                    style={{
                                        background: 'none', border: 'none', cursor: 'pointer',
                                        padding: 2, display: 'flex', alignItems: 'center',
                                        color: isCreatorFav ? '#f59e0b' : '#d1d5db',
                                        transition: 'color 0.2s transform 0.15s',
                                        transform: isCreatorFav ? 'scale(1.15)' : 'scale(1)',
                                    }}
                                >
                                    <Star size={16} fill={isCreatorFav ? '#f59e0b' : 'none'} />
                                </button>
                            </div>
                            {creator.marketplaces ? <div style={{ display: 'flex', gap: 6, margin: '4px 0 10px' }}>
                                {creator.marketplaces.map((m, i) => (
                                    <img key={i} src={`/icons/${m}.png`} alt={m} style={{ width: 22, height: 22, objectFit: 'contain' }} />
                                ))}
                            </div> : <div style={{ height: '9px' }}></div>}
                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
                                {creator.links.map((link, i) => (
                                    <a key={i} href={link.url} target="_blank" rel="noopener noreferrer"
                                        onClick={e => e.stopPropagation()}
                                        style={{
                                            display: 'inline-flex', alignItems: 'center', gap: 5,
                                            padding: '4px 10px', borderRadius: 20, fontSize: 11, fontWeight: 600,
                                            border: `1px solid ${creator.accentColor}44`,
                                            color: creator.accentColor, background: `${creator.accentColor}12`,
                                            textDecoration: 'none',
                                        }}>
                                        <LinkIcon icon={link.icon} size={11} />
                                        {link.label}
                                    </a>
                                ))}
                            </div>
                        </div>
                    </div>
                    <p style={{ marginTop: 12, color: '#4b5563', fontSize: 13, lineHeight: 1.65 }}>{creator.description}</p>
                    {creator.services && (
                        <p style={{ marginTop: 8, color: '#4b5563', fontSize: 13, lineHeight: 1.65 }}>
                            <strong>Services:</strong> {creator.services}
                        </p>
                    )}
                    <button
                        onClick={() => setModalOpen(true)}
                        style={{
                            marginTop: 18, width: '100%', padding: '11px 0', borderRadius: 11,
                            border: 'none', cursor: 'pointer', fontSize: 13, fontWeight: 700,
                            background: `${creator.accentColor}15`, color: creator.accentColor,
                            display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8,
                        }}>
                        <Play size={13} fill={creator.accentColor} />
                        See how they use MSP
                        <span style={{ fontSize: 11, fontWeight: 400, opacity: 0.7 }}>
                            {totalVideos} video{totalVideos !== 1 ? 's' : ''}
                        </span>
                    </button>
                    {watchedCount > 0 && (
                        <div style={{ display: 'flex', justifyContent: 'center', marginTop: 6 }}>
                            <span style={{
                                fontSize: 10, fontWeight: 700, background: '#d1fae5', color: '#059669',
                                borderRadius: 20, padding: '3px 10px',
                            }}>
                                ✓ {watchedCount} watched
                            </span>
                        </div>
                    )}
                </div>
            </div>
            {modalOpen && (
                <Modal
                    creator={creator} tab={tab} onClose={() => setModalOpen(false)}
                    userData={userData} onToggleWatched={onToggleWatched}
                    onToggleFavorite={onToggleFavorite} onSetNote={onSetNote}
                />
            )}
        </>
    );
};

/* ═══════════════════════════════════════════════════════════════
   RECORDED CALLS SECTION
═══════════════════════════════════════════════════════════════ */
const CALLS_PAGE_SIZE = 6;

const CallsSection = ({ label, icon: Icon, color, calls }) => {
    const [visibleCount, setVisibleCount] = useState(CALLS_PAGE_SIZE);
    const [loadingMore, setLoadingMore] = useState(false);
    const containerRef = useRef(null);
    const sentinelRef = useRef(null);

    useEffect(() => {
        const container = containerRef.current;
        const sentinel = sentinelRef.current;
        if (!container || !sentinel) return;

        const observer = new IntersectionObserver((entries) => {
            const entry = entries[0];
            if (entry.isIntersecting && visibleCount < calls.length && !loadingMore) {
                setLoadingMore(true);
                setTimeout(() => {
                    setVisibleCount(v => Math.min(v + CALLS_PAGE_SIZE, calls.length));
                    setLoadingMore(false);
                }, 400);
            }
        }, { root: container, rootMargin: '200px', threshold: 0 });

        observer.observe(sentinel);
        return () => observer.disconnect();
    }, [visibleCount, loadingMore, calls.length]);

    const visibleCalls = calls.slice(0, visibleCount);

    return (
        <div style={{ background: '#fff', borderRadius: 18, border: '1px solid #e5e7eb', overflow: 'hidden' }}>
            <div style={{ padding: '20px 24px 16px', borderBottom: '1px solid #f0f0f0', display: 'flex', alignItems: 'center', gap: 10 }}>
                <Icon size={20} color={color} />
                <h3 style={{ fontSize: 15, fontWeight: 700, color: '#111', margin: 0 }}>{label} - Recorded Calls</h3>
                <span style={{
                    marginLeft: 'auto', fontSize: 11, padding: '2px 8px', borderRadius: 20,
                    background: `${color}18`, color, fontWeight: 600,
                }}>{calls.length} sessions</span>
            </div>
            <div ref={containerRef} style={{ padding: '20px 24px 24px', maxHeight: '500px', overflow: 'auto' }}>
                {visibleCalls.length > 0 && (
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(340px, 1fr))', gap: 20 }}>
                        {visibleCalls.map((item, i) => (
                            <div key={i} style={{ borderRadius: 14, overflow: 'hidden', border: '1px solid #e5e7eb' }}>
                                <div style={{ aspectRatio: '16/9', background: '#000' }}>
                                    <iframe
                                        src={`${item.url}?rel=0`} title={item.title} frameBorder="0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                        allowFullScreen style={{ width: '100%', height: '100%', display: 'block' }}
                                    />
                                </div>
                                {item.title && (
                                    <div style={{ background: '#fff', padding: '10px 14px', borderTop: '1px solid #f0f0f0', display: 'flex', alignItems: 'center', gap: 8 }}>
                                        <Youtube size={14} color="#ff0000" />
                                        <p style={{ fontSize: 13, fontWeight: 600, color: '#374151', margin: 0 }}>{item.title}</p>
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                )}
                {visibleCount < calls.length && (
                    <div ref={sentinelRef} style={{ textAlign: 'center', padding: '20px 0 4px', color: '#9ca3af', fontSize: 12, fontWeight: 600 }}>
                        {loadingMore ? 'Loading more…' : 'Scroll for more'}
                    </div>
                )}
            </div>
        </div>
    );
};

/* ═══════════════════════════════════════════════════════════════
   SPANISH VIDEOS SECTION
═══════════════════════════════════════════════════════════════ */
const SpanishVideosSection = () => {
    const c = SPANISH_CREATOR;
    const initials = c.name.split(' ').map(n => n[0]).join('');

    return (
        <div style={{ maxWidth: 1100, margin: '0 auto', padding: '32px 24px 40px' }}>

            {/* Creator banner */}
            <div style={{
                background: '#fff', borderRadius: 18, border: '1px solid #e5e7eb',
                borderTop: `4px solid ${c.accentColor}`,
                padding: '24px 28px', marginBottom: 28,
                display: 'flex', alignItems: 'center', gap: 20, flexWrap: 'wrap',
            }}>
                <div style={{
                    width: 72, height: 72, borderRadius: '50%', flexShrink: 0, overflow: 'hidden',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    background: c.photo ? '#f3f4f6' : c.accentColor,
                    border: `2.5px solid ${c.accentColor}`,
                    color: '#fff', fontWeight: 700, fontSize: 22,
                }}>
                    {c.photo
                        ? <img src={c.photo} alt={c.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                        : initials}
                </div>

                <div style={{ flex: 1, minWidth: 200 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 4, flexWrap: 'wrap' }}>
                        <h2 style={{ fontSize: 20, fontWeight: 800, color: '#111', margin: 0 }}>{c.name}</h2>
                    </div>
                    <p style={{ color: '#4b5563', fontSize: 13, lineHeight: 1.6, margin: '0 0 10px' }}>{c.description}</p>
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
                        {c.links.map((link, i) => (
                            <a key={i} href={link.url} target="_blank" rel="noopener noreferrer"
                                style={{
                                    display: 'inline-flex', alignItems: 'center', gap: 5,
                                    padding: '4px 10px', borderRadius: 20, fontSize: 11, fontWeight: 600,
                                    border: `1px solid ${c.accentColor}44`,
                                    color: c.accentColor, background: `${c.accentColor}12`,
                                    textDecoration: 'none',
                                }}>
                                <LinkIcon icon={link.icon} size={11} />
                                {link.label}
                            </a>
                        ))}
                    </div>
                </div>
                <div style={{ flexShrink: 0, textAlign: 'center' }}>
                    <div style={{ fontSize: 28, fontWeight: 800, color: c.accentColor }}>{SPANISH_VIDEOS.length}</div>
                    <div style={{ fontSize: 11, color: '#9ca3af', fontWeight: 600 }}>videos</div>
                </div>
                <div style={{ width: '100%', textAlign: 'center', margin: '16px 0 4px' }}>
                    <a
                        href="https://www.facebook.com/groups/mspespanol"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                            display: 'inline-flex', alignItems: 'center', gap: 10,
                            padding: '14px 32px', borderRadius: 14,
                            background: '#1877F2', color: '#fff',
                            fontWeight: 800, fontSize: 16, textDecoration: 'none',
                            boxShadow: '0 4px 18px #1877F244',
                        }}
                    >
                        <Facebook size={20} />
                        Únete a nuestra comunidad MultiSellerPro en Español
                    </a>
                </div>
            </div>

            {/* 3-column video grid */}
            {SPANISH_VIDEOS.length > 0 ? (
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 20 }}>
                    {SPANISH_VIDEOS.map((v, i) => (
                        <div key={i} style={{ borderRadius: 14, overflow: 'hidden', border: '1px solid #e5e7eb', background: '#fff' }}>
                            <div style={{ aspectRatio: '16/9', background: '#000' }}>
                                <iframe
                                    src={`${v.url}?rel=0`} title={v.title} frameBorder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen style={{ width: '100%', height: '100%', display: 'block' }}
                                />
                            </div>
                            <div style={{ padding: '10px 14px 12px', borderTop: '1px solid #f0f0f0', display: 'flex', alignItems: 'flex-start', gap: 8 }}>
                                <Youtube size={14} color="#ff0000" style={{ flexShrink: 0, marginTop: 2 }} />
                                <p style={{ fontSize: 13, fontWeight: 600, color: '#374151', margin: 0, lineHeight: 1.45 }}>{v.title}</p>
                            </div>
                        </div>
                    ))}
                </div>
            ) : (
                <div style={{ textAlign: 'center', padding: '80px 0', color: '#9ca3af', fontSize: 16 }}>
                    ¡Próximamente! Videos en español - vuelve pronto.
                </div>
            )}
        </div>
    );
};

/* ═══════════════════════════════════════════════════════════════
   WELCOME SECTION
═══════════════════════════════════════════════════════════════ */
const WelcomeSection = () => (
    <div style={{ maxWidth: 900, margin: '0 auto', padding: '56px 24px 40px' }}>
        <style>{`
            @keyframes msp-wave {
                0%, 60%, 100% { transform: rotate(0deg); }
                10% { transform: rotate(14deg); }
                20% { transform: rotate(-8deg); }
                30% { transform: rotate(14deg); }
                40% { transform: rotate(-4deg); }
                50% { transform: rotate(10deg); }
            }
            @keyframes msp-fade-up {
                from { opacity: 0; transform: translateY(18px); }
                to { opacity: 1; transform: translateY(0); }
            }
            .msp-wave { display: inline-block; transform-origin: 70% 70%; animation: msp-wave 2.2s ease-in-out infinite; }
            .msp-fade-up { animation: msp-fade-up 0.7s ease-out both; }
        `}</style>

        {/* Hey + emoji */}
        <div className="msp-fade-up" style={{ textAlign: 'center', marginBottom: 36, marginTop: "-3%" }}>
            <h1 style={{ fontSize: 38, fontWeight: 800, color: '#111', margin: 0, lineHeight: 1.1 }}>
                Hey <span className="msp-wave">👋</span>
            </h1>
        </div>

        {/* Video / placeholder */}
        <div className="msp-fade-up" style={{ animationDelay: '0.25s' }}>
            <div style={{ aspectRatio: '16/9', borderRadius: 18, overflow: 'hidden', background: '#000', border: '1px solid #e5e7eb', boxShadow: '0 10px 30px rgba(0,0,0,0.08)' }}>
                <iframe
                    src={`https://www.youtube.com/embed/e4oVVGt97Js?rel=0`} title="Welcome" frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen style={{ width: '100%', height: '100%', display: 'block' }}
                />
            </div>
        </div>
    </div>
);

/* ═══════════════════════════════════════════════════════════════
   CHAT CALLOUT (our own element, points at the chat bubble)
═══════════════════════════════════════════════════════════════ */
const ChatCallout = () => {
    const openChat = () => {
        const btn = document.getElementById('cgptcb-chat-circle');
        if (btn) btn.click();
    };

    return (
        <div
            onClick={openChat}
            style={{
                position: 'fixed', top: '94.5%', left: '95%',
                transform: 'translate(-100%, -50%)', zIndex: 2147483000, cursor: 'pointer',
            }}
        >
            <style>{`
                @keyframes msp-callout-nudge {
                    0%, 100% { transform: translateX(0); }
                    50%      { transform: translateX(-8px); }
                }
                .msp-callout-inner { display: flex; align-items: center; animation: msp-callout-nudge 1.4s ease-in-out infinite; }
                @media (max-width: 600px) { .msp-callout-text { font-size: 11px !important; padding: 6px 10px !important; } }
            `}</style>
            <div className="msp-callout-inner">
                <div className="msp-callout-text" style={{
                    background: '#0052cc', color: '#fff', fontSize: 13, fontWeight: 700,
                    padding: '8px 14px', borderRadius: 20, whiteSpace: 'nowrap',
                    boxShadow: '0 4px 14px rgba(0, 82, 204, 0.35)',
                }}>
                    Click me to ask any question!
                </div>
                <div style={{
                    width: 0, height: 0,
                    borderTop: '8px solid transparent', borderBottom: '8px solid transparent',
                    borderLeft: '12px solid #0052cc',
                }} />
            </div>
        </div>
    );
};

/* ═══════════════════════════════════════════════════════════════
   MAIN PAGE
═══════════════════════════════════════════════════════════════ */
const IntroVideoBox = ({ tab }) => {
    const intro = INTRO_VIDEOS[tab];
    if (!intro) return null;
    const Icon = intro.icon;

    return (
        <div style={{ maxWidth: 1100, margin: '0 auto', padding: '24px 24px 16px' }}>
            <style>{`
                @keyframes msp-bounce-down {
                    0%, 100% { transform: translateY(-1px); }
                    50% { transform: translateY(4px); }
                }
                .msp-scroll-hint { display: inline-block; animation: msp-bounce-down 1.4s ease-in-out infinite; }
            `}</style>
            <div style={{
                background: '#fff', borderRadius: 16, border: '1px solid #e5e7eb',
                borderLeft: `4px solid ${intro.color}`,
                padding: 16, display: 'flex', alignItems: 'center', gap: 20, flexWrap: 'wrap',
            }}>
                <div style={{
                    width: 360, maxWidth: '100%', aspectRatio: '16/9', flexShrink: 0,
                    borderRadius: 12, overflow: 'hidden', background: '#000',
                }}>
                    <iframe
                        src={`${intro.url}?rel=0`} title={intro.title} frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen style={{ width: '100%', height: '100%', display: 'block' }}
                    />
                </div>
                <div style={{ flex: 1, minWidth: 220 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6 }}>
                        <Icon size={18} color={intro.color} />
                        <h3 style={{ fontSize: 17, fontWeight: 800, color: '#111', margin: 0 }}>{intro.title}</h3>
                    </div>
                    <p style={{ fontSize: 13, color: '#6b7280', margin: '0 0 14px', lineHeight: 1.5 }}>{intro.subtitle}</p>
                    <div style={{
                        display: 'inline-flex', alignItems: 'center', gap: 6,
                        fontSize: 12, fontWeight: 700, color: intro.color,
                        background: `${intro.color}12`, border: `1px solid ${intro.color}33`,
                        padding: '6px 12px', borderRadius: 20,
                    }}>
                        Scroll down to see how different {tab == 'seller' ? 'sellers' : 'influencers'} use it
                        <span className="msp-scroll-hint">↓</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

const HowIUseMSPPage = () => {
    const [tab, setTab] = useState('welcome');
    const { data: userData, toggleWatched, toggleFavorite, setNote, toggleCreatorFavorite } = useUserData();
    const creators = tab === 'seller' ? SELLERS : INFLUENCERS;

    const tabs = [
        { id: 'welcome', label: 'Welcome', icon: Sparkles, color: '#f59e0b', count: null },
        { id: 'seller', label: 'Seller Pro', icon: ShoppingBag, color: '#0d9488', count: SELLERS.length },
        { id: 'influencer', label: 'Influencer Pro', icon: Tv, color: '#2563eb', count: INFLUENCERS.length },
        { id: 'calls', label: 'Recorded Calls', icon: Video, color: '#7c3aed', count: RECORDED_CALLS.seller.length + RECORDED_CALLS.influencer.length + RECORDED_CALLS.general.length },
        { id: 'spanish', label: 'En Español', icon: Youtube, color: '#dc2626', count: SPANISH_VIDEOS.length },
    ];

    return (
        <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg, #f8fafc 0%, #eff6ff 100%)' }}>
            <ChatCallout />

            {/* Tab bar */}
            <div style={{ background: '#fff', borderBottom: '1px solid #f0f0f0', position: 'sticky', top: 0, zIndex: 10 }}>
                <div style={{ maxWidth: 1100, margin: '0 auto', padding: '0 24px', display: 'flex' }}>
                    {tabs.map(t => (
                        <button key={t.id} onClick={() => setTab(t.id)} style={{
                            display: 'flex', alignItems: 'center', gap: 8, padding: '14px 22px',
                            border: 'none', background: 'none', cursor: 'pointer', fontSize: 14, fontWeight: 600,
                            color: tab === t.id ? t.color : '#94a3b8',
                            borderBottom: `2px solid ${tab === t.id ? t.color : 'transparent'}`,
                            transition: 'color 0.2s, border-color 0.2s', whiteSpace: 'nowrap',
                        }}>
                            <t.icon size={15} />
                            {t.label}
                            {t.count != null && (
                                <span style={{
                                    fontSize: 11, padding: '2px 8px', borderRadius: 20, fontWeight: 600,
                                    background: tab === t.id ? `${t.color}22` : '#f1f5f9',
                                    color: tab === t.id ? t.color : '#94a3b8',
                                }}>{t.count}</span>
                            )}
                        </button>
                    ))}
                </div>
            </div>

            {/* Creator cards */}
            {(tab === 'seller' || tab === 'influencer') && (<>
                <IntroVideoBox tab={tab} />
                <div style={{ maxWidth: 1100, margin: '0 auto', padding: '0 24px 32px', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))', gap: 20 }}>
                    {creators.map(creator => (
                        <CreatorCard
                            key={creator.id} creator={creator} tab={tab} userData={userData}
                            onToggleWatched={toggleWatched} onToggleFavorite={toggleFavorite}
                            onSetNote={setNote} onToggleCreatorFavorite={toggleCreatorFavorite}
                        />
                    ))}
                    {creators.length === 0 && (
                        <div style={{ gridColumn: '1/-1', textAlign: 'center', padding: '80px 0', color: '#9ca3af', fontSize: 16 }}>
                            No stories yet - check back soon!
                        </div>
                    )}
                </div>
            </>)}

            {/* Recorded calls */}
            {tab === 'calls' && (<>
                <div style={{ maxWidth: 1100, margin: '0 auto', padding: '32px 24px', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(340px, 1fr))', gap: 20 }}>
                    <CallsSection label="Seller Pro" icon={ShoppingBag} color="#0d9488" calls={RECORDED_CALLS.seller} />
                    <CallsSection label="Influencer Pro" icon={Tv} color="#2563eb" calls={RECORDED_CALLS.influencer} />
                </div>
                <div style={{ maxWidth: 1100, margin: '0 auto', padding: '0 24px 32px' }}>
                    <CallsSection label="MSP (Both)" icon={Film} color="#00cb22" calls={RECORDED_CALLS.general} />
                </div>
            </>)}

            {/* Welcome */}
            {tab === 'welcome' && <WelcomeSection />}

            {/* Spanish videos */}
            {tab === 'spanish' && <SpanishVideosSection />}

            {tab !== 'welcome' && <div style={{ textAlign: 'center', padding: '24px', color: 'black', fontWeight: "700", fontSize: 13 }}>
                Want to add your videos and socials here? Send us an email / DM!
            </div>}
        </div>
    );
};

export default HowIUseMSPPage;